// src/enums.ts
var UserRole = {
  USER: 0,
  ADMIN: 1,
  ARTIST: 2,
  SUBSCRIBER: 3,
  TEAM: 4
};
var ADMIN_WALLET = "6Qxu5cRDNFEZvYtgtvo27tdg7LuT5wuX7THqqPbBWJmT";
var SpecialWallets = {
  SHADER_TOM: ADMIN_WALLET
  // Add more special users here as needed
};
var UserStatus = {
  OFFLINE: 0,
  ONLINE: 1,
  AWAY: 2,
  BUSY: 3
};
var ActivityType = {
  IDLE: 0,
  CODING: 1,
  LISTENING: 2,
  BROWSING: 3
};
var CurrentPage = {
  HOME: 0,
  VISUALIZER: 1,
  SKETCHES: 2,
  STUDIES: 3,
  PROFILE: 4,
  SETTINGS: 5,
  // Admin pages
  DASHBOARD: 6,
  PROJECTS: 7,
  PROJECT_DETAIL: 8,
  // UI pages
  DESIGN: 9,
  GIST: 10,
  AUDIUS_HOME: 11,
  AUDIUS_PLAYLIST_DETAIL: 12,
  AUDIUS_USER_DETAIL: 13,
  PAGE_NOT_FOUND: 14
};
var AudioSource = {
  NONE: 0,
  SPOTIFY: 1,
  AUDIUS: 2,
  RADIO_PARADISE: 3,
  MICROPHONE: 4,
  FILE: 5,
  BROWSER_AUDIO: 6,
  KEXP: 7
};
var RadioSource = {
  RADIO_PARADISE: 0,
  KEXP: 1
};
var RadioParadiseStation = {
  MAIN_MIX: 0,
  MELLOW_MIX: 1,
  ROCK_MIX: 2,
  GLOBAL_MIX: 3
};
var RadioStreamUrls = {
  RADIO_PARADISE: {
    [RadioParadiseStation.MAIN_MIX]: {
      mp3: "http://stream.radioparadise.com/aac-320",
      flac: "http://stream.radioparadise.com/flac"
    },
    [RadioParadiseStation.MELLOW_MIX]: {
      mp3: "http://stream.radioparadise.com/mellow-320",
      flac: "http://stream.radioparadise.com/mellow-flac"
    },
    [RadioParadiseStation.ROCK_MIX]: {
      mp3: "http://stream.radioparadise.com/rock-320",
      flac: "http://stream.radioparadise.com/rock-flac"
    },
    [RadioParadiseStation.GLOBAL_MIX]: {
      mp3: "http://stream.radioparadise.com/global-320",
      flac: "http://stream.radioparadise.com/global-flac"
    }
  },
  KEXP: {
    mp3: "https://kexp.streamguys1.com/kexp160.aac"
  }
};
var PlaybackState = {
  STOPPED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3
};
var SpaceType = {
  GLOBAL_ACTIVE: 0,
  CODING_ROOM: 1,
  LISTENING_PARTY: 2,
  CREATIVE_LAB: 3,
  PRIVATE_ROOM: 4
};
var SpaceVisibility = {
  PUBLIC: 0,
  UNLISTED: 1,
  PRIVATE: 2
};
var DeviceType = {
  DESKTOP: 0,
  MOBILE: 1,
  TABLET: 2,
  VR: 3,
  WATCH: 4,
  TV: 5,
  CONSOLE: 6
};
var ClientPlatform = {
  WEB: 0,
  ELECTRON: 1,
  MOBILE_APP: 2
};
var ContentVisibility = {
  PRIVATE: 0,
  PUBLIC: 1,
  UNLISTED: 2,
  FRIENDS_ONLY: 3
};
var ShaderCategory = {
  UNCATEGORIZED: 0,
  VISUAL_MUSIC: 1,
  ABSTRACT: 2,
  GENERATIVE: 3,
  INTERACTIVE: 4,
  EXPERIMENTAL: 5
};
var TaskStatus = {
  TODO: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  CANCELLED: 3
};
var TaskPriority = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
  URGENT: 3
};
var ProjectStatus = {
  ACTIVE: 0,
  ARCHIVED: 1,
  COMPLETED: 2,
  ON_HOLD: 3
};
function enumToString(enumObject, value) {
  const key = Object.keys(enumObject).find((k) => enumObject[k] === value);
  return key || "UNKNOWN";
}
function enumKeyToLabel(enumKey) {
  return enumKey.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
}
function getEnumValues(enumObject) {
  return Object.values(enumObject).filter((v) => typeof v === "number");
}
function isValidEnumValue(enumObject, value) {
  return getEnumValues(enumObject).includes(value);
}
var UserStateField = {
  STATUS: 0,
  // online/offline/away/busy
  PAGE: 1,
  // current page/route  
  AUDIO_SOURCE: 2,
  // spotify/audius/etc
  AUDIO_TRACK: 3,
  // current track hash
  AUDIO_POSITION: 4,
  // playback timestamp
  GEO_LAT: 5,
  // latitude for globe
  GEO_LNG: 6,
  // longitude for globe  
  DEVICE_TYPE: 7,
  // desktop/mobile/tablet
  CLIENT_PLATFORM: 8,
  // web/electron/mobile
  LAST_SEEN: 9,
  // timestamp
  ACTIVITY_TYPE: 10,
  // coding/listening/browsing
  SHADER_ID: 11,
  // current shader being viewed/edited
  PROJECT_ID: 12
  // current project space
};
var AnalyticsMetric = {
  PAGE_VIEW: 0,
  SHADER_VIEW: 1,
  TRACK_PLAY: 2,
  PROJECT_JOIN: 3,
  COLLABORATION_EVENT: 4,
  AUDIO_SOURCE_SWITCH: 5,
  GLOBE_INTERACTION: 6
};
var GeoRegion = {
  NORTH_AMERICA: 0,
  SOUTH_AMERICA: 1,
  EUROPE: 2,
  ASIA: 3,
  AFRICA: 4,
  OCEANIA: 5,
  ANTARCTICA: 6
};
var AppTarget = {
  WEB: 0,
  // Standard web app (kaleidosync.com)
  PWA: 1,
  // Progressive Web App with service worker
  CHROME: 2,
  // Chrome extension overlay
  FIREFOX: 3,
  // Firefox extension
  EDGE: 4,
  // Microsoft Edge extension
  ELECTRON: 5,
  // Electron desktop app
  WIDGET: 6,
  // Embeddable iframe widget
  CDN: 7,
  // CDN-hosted script for any website
  DEV: 8
  // Development mode with hot reload
};
var OperatingSystem = {
  MACOS: 13,
  IOS: 14,
  WINDOWS: 15,
  LINUX: 16,
  ANDROID: 17,
  WINDOWS_MOBILE: 18,
  CHROME_OS: 19,
  UBUNTU: 20,
  DEBIAN: 21,
  FEDORA: 22,
  ARCH: 23
};
var Country = {
  UNITED_STATES: 24,
  CANADA: 25,
  UNITED_KINGDOM: 26,
  GERMANY: 27,
  FRANCE: 28,
  JAPAN: 29,
  AUSTRALIA: 30,
  BRAZIL: 31,
  INDIA: 32,
  CHINA: 33,
  RUSSIA: 34,
  ITALY: 35,
  SPAIN: 36,
  NETHERLANDS: 37,
  SWEDEN: 38,
  NORWAY: 39,
  DENMARK: 40,
  FINLAND: 41,
  SOUTH_KOREA: 42,
  SINGAPORE: 43,
  NEW_ZEALAND: 44,
  SWITZERLAND: 45,
  AUSTRIA: 46,
  BELGIUM: 47,
  PORTUGAL: 48,
  IRELAND: 49,
  POLAND: 50,
  CZECH_REPUBLIC: 51,
  HUNGARY: 52,
  GREECE: 53,
  TURKEY: 54,
  ISRAEL: 55,
  UAE: 56,
  SAUDI_ARABIA: 57,
  SOUTH_AFRICA: 58,
  MEXICO: 59,
  ARGENTINA: 60,
  CHILE: 61,
  COLOMBIA: 62,
  PERU: 63,
  THAILAND: 64,
  VIETNAM: 65,
  PHILIPPINES: 66,
  INDONESIA: 67,
  MALAYSIA: 68,
  TAIWAN: 69,
  HONG_KONG: 70
};
var ShaderType = {
  FRAGMENT: 71,
  VERTEX: 72,
  COMPUTE: 73,
  GEOMETRY: 74,
  TESSELLATION: 75
};
var VisualTag = {
  AUDIO_REACTIVE: 76,
  GENERATIVE: 77,
  PARTICLE_SYSTEM: 78,
  FRACTAL: 79,
  CYBERPUNK: 80,
  ABSTRACT: 81,
  GEOMETRIC: 82,
  ORGANIC: 83,
  GLITCH: 84,
  MINIMALIST: 85,
  COLORFUL: 86,
  MONOCHROME: 87,
  PSYCHEDELIC: 88,
  RETRO: 89,
  FUTURISTIC: 90,
  NATURE: 91,
  SPACE: 92,
  UNDERWATER: 93,
  FIRE: 94,
  ICE: 95,
  LIGHTNING: 96,
  SMOKE: 97,
  FLUID: 98,
  CRYSTAL: 99,
  NEON: 100
};
var PerformanceLevel = {
  LOW: 101,
  MEDIUM: 102,
  HIGH: 103,
  ULTRA: 104,
  MOBILE_OPTIMIZED: 105,
  VR_OPTIMIZED: 106,
  EXPERIMENTAL: 107
};
var Quality = {
  SD: 108,
  // 480p
  HD: 109,
  // 720p
  FHD: 110,
  // 1080p
  QHD: 111,
  // 1440p
  UHD_4K: 112,
  // 2160p
  UHD_8K: 113,
  // 4320p
  MOBILE: 114,
  // Mobile optimized
  RETINA: 115
  // High DPI displays
};
var Framework = {
  THREEJS: 116,
  WEBGL: 117,
  WEBGPU: 118,
  SHADERTOY: 119,
  OPENGL: 120,
  VULKAN: 121,
  DIRECTX: 122,
  METAL: 123,
  GLSL: 124,
  HLSL: 125,
  WGSL: 126,
  P5JS: 127,
  PROCESSING: 128,
  UNITY: 129,
  UNREAL: 130
};
var TimePeriod = {
  TODAY: 131,
  YESTERDAY: 132,
  WEEK: 133,
  MONTH: 134,
  QUARTER: 135,
  YEAR: 136,
  ALL_TIME: 137,
  LAST_7_DAYS: 138,
  LAST_30_DAYS: 139,
  LAST_90_DAYS: 140,
  LAST_365_DAYS: 141
};
var SortBy = {
  CREATED_AT: 142,
  UPDATED_AT: 143,
  POPULARITY: 144,
  LIKES: 145,
  VIEWS: 146,
  ALPHABETICAL: 147,
  RATING: 148,
  TRENDING: 149,
  FEATURED: 150,
  RECENT: 151,
  DOWNLOADS: 152,
  COMMENTS: 153,
  SHARES: 154,
  DURATION: 155,
  SIZE: 156,
  COMPLEXITY: 157
};
var SortOrder = {
  ASC: 158,
  DESC: 159,
  ASCENDING: 160,
  DESCENDING: 161
};
var CollaborationRole = {
  OWNER: 162,
  COLLABORATOR: 163,
  VIEWER: 164,
  COMMENTER: 165,
  EDITOR: 166,
  ADMIN: 167,
  MODERATOR: 168,
  GUEST: 169
};
var RouterModeMap = {
  [AppTarget.WEB]: "history",
  [AppTarget.PWA]: "history",
  [AppTarget.CHROME]: "overlay",
  [AppTarget.FIREFOX]: "overlay",
  [AppTarget.EDGE]: "overlay",
  [AppTarget.ELECTRON]: "memory",
  [AppTarget.WIDGET]: "memory",
  [AppTarget.CDN]: "memory",
  [AppTarget.DEV]: "history"
};
var SocketCore = {
  CONNECTED: 170,
  DISCONNECTED: 171,
  AUTHENTICATED: 172,
  UNAUTHENTICATED: 173,
  ERROR: 174,
  RECONNECTING: 175,
  TIMEOUT: 176
};
var SocketRoom = {
  JOINED: 177,
  LEFT: 178,
  USER_JOINED: 179,
  USER_LEFT: 180,
  ROOM_CREATED: 181,
  ROOM_DESTROYED: 182
};
var SocketEntity = {
  PROJECT: 183,
  BUCKET: 184,
  TASK: 185,
  STUDY: 186,
  USER: 187,
  COLLABORATION: 188,
  MESSAGE: 189,
  NOTIFICATION: 190,
  SPACE: 191,
  AUDIO: 192
};
var SocketCrud = {
  CREATE: 193,
  UPDATE: 194,
  DELETE: 195,
  MOVE: 196,
  RESTORE: 197,
  ARCHIVE: 198
};
var SocketSocial = {
  FOLLOW: 199,
  UNFOLLOW: 200,
  INVITE: 201,
  REMOVE: 202,
  ACCEPT: 203,
  REJECT: 204,
  PROMOTE: 205,
  DEMOTE: 206
};
var SocketActivity = {
  CURSOR_MOVE: 207,
  DRAG_START: 208,
  DRAG_END: 209,
  TYPING_START: 210,
  TYPING_END: 211,
  PRESENCE_UPDATE: 212,
  STATUS_CHANGE: 213
};
function generateSocketEvent(entity, action) {
  const entityName = enumToString(SocketEntity, entity).toLowerCase();
  const actionName = enumToString({ ...SocketCrud, ...SocketSocial, ...SocketActivity, ...SocketCore, ...SocketRoom }, action).toLowerCase();
  return `${entityName}:${actionName}`;
}
var SocketEvents = {
  // Core connection events
  CORE_CONNECTED: "core:connected",
  CORE_DISCONNECTED: "core:disconnected",
  CORE_AUTHENTICATED: "core:authenticated",
  CORE_ERROR: "core:error",
  // Space management
  SPACE_JOINED: "space:joined",
  SPACE_LEFT: "space:left",
  SPACE_USER_JOINED: "space:user:joined",
  SPACE_USER_LEFT: "space:user:left",
  // Space entity CRUD - Projects
  SPACE_PROJECT_CREATE: "space:project:create",
  SPACE_PROJECT_UPDATE: "space:project:update",
  SPACE_PROJECT_DELETE: "space:project:delete",
  SPACE_PROJECT_ARCHIVE: "space:project:archive",
  // Space entity CRUD - Buckets  
  SPACE_BUCKET_CREATE: "space:bucket:create",
  SPACE_BUCKET_UPDATE: "space:bucket:update",
  SPACE_BUCKET_DELETE: "space:bucket:delete",
  // Space entity CRUD - Tasks
  SPACE_TASK_CREATE: "space:task:create",
  SPACE_TASK_UPDATE: "space:task:update",
  SPACE_TASK_DELETE: "space:task:delete",
  SPACE_TASK_MOVE: "space:task:move",
  // Space entity CRUD - Studies
  SPACE_STUDY_CREATE: "space:study:create",
  SPACE_STUDY_UPDATE: "space:study:update",
  SPACE_STUDY_DELETE: "space:study:delete",
  // Space social actions
  SPACE_USER_FOLLOW: "space:user:follow",
  SPACE_USER_UNFOLLOW: "space:user:unfollow",
  // Space collaboration management
  SPACE_COLLABORATION_INVITE: "space:collaboration:invite",
  SPACE_COLLABORATION_REMOVE: "space:collaboration:remove",
  SPACE_COLLABORATION_ACCEPT: "space:collaboration:accept",
  SPACE_COLLABORATION_REJECT: "space:collaboration:reject",
  // Space real-time activities
  SPACE_CURSOR_MOVE: "space:cursor:move",
  SPACE_DRAG_START: "space:drag:start",
  SPACE_DRAG_END: "space:drag:end",
  SPACE_TYPING_START: "space:typing:start",
  SPACE_TYPING_END: "space:typing:end",
  SPACE_PRESENCE_UPDATE: "space:presence:update",
  // Space messaging
  SPACE_MESSAGE_SEND: "space:message:create",
  SPACE_MESSAGE_UPDATE: "space:message:update",
  SPACE_MESSAGE_DELETE: "space:message:delete",
  // Space notifications
  SPACE_NOTIFICATION_CREATE: "space:notification:create",
  SPACE_NOTIFICATION_UPDATE: "space:notification:update",
  SPACE_NOTIFICATION_DELETE: "space:notification:delete"
};
var SocketEventCategories = {
  CORE: [SocketEvents.CORE_CONNECTED, SocketEvents.CORE_DISCONNECTED, SocketEvents.CORE_AUTHENTICATED, SocketEvents.CORE_ERROR],
  SPACE_MANAGEMENT: [SocketEvents.SPACE_JOINED, SocketEvents.SPACE_LEFT, SocketEvents.SPACE_USER_JOINED, SocketEvents.SPACE_USER_LEFT],
  SPACE_PROJECT_CRUD: [SocketEvents.SPACE_PROJECT_CREATE, SocketEvents.SPACE_PROJECT_UPDATE, SocketEvents.SPACE_PROJECT_DELETE, SocketEvents.SPACE_PROJECT_ARCHIVE],
  SPACE_BUCKET_CRUD: [SocketEvents.SPACE_BUCKET_CREATE, SocketEvents.SPACE_BUCKET_UPDATE, SocketEvents.SPACE_BUCKET_DELETE],
  SPACE_TASK_CRUD: [SocketEvents.SPACE_TASK_CREATE, SocketEvents.SPACE_TASK_UPDATE, SocketEvents.SPACE_TASK_DELETE, SocketEvents.SPACE_TASK_MOVE],
  SPACE_STUDY_CRUD: [SocketEvents.SPACE_STUDY_CREATE, SocketEvents.SPACE_STUDY_UPDATE, SocketEvents.SPACE_STUDY_DELETE],
  SPACE_SOCIAL: [SocketEvents.SPACE_USER_FOLLOW, SocketEvents.SPACE_USER_UNFOLLOW, SocketEvents.SPACE_COLLABORATION_INVITE, SocketEvents.SPACE_COLLABORATION_REMOVE],
  SPACE_ACTIVITY: [SocketEvents.SPACE_CURSOR_MOVE, SocketEvents.SPACE_DRAG_START, SocketEvents.SPACE_DRAG_END, SocketEvents.SPACE_TYPING_START, SocketEvents.SPACE_TYPING_END],
  SPACE_MESSAGING: [SocketEvents.SPACE_MESSAGE_SEND, SocketEvents.SPACE_MESSAGE_UPDATE, SocketEvents.SPACE_MESSAGE_DELETE],
  SPACE_NOTIFICATIONS: [SocketEvents.SPACE_NOTIFICATION_CREATE, SocketEvents.SPACE_NOTIFICATION_UPDATE, SocketEvents.SPACE_NOTIFICATION_DELETE]
};
var RedisKeys = {
  // User ID mapping (wallet address <-> integer ID)
  walletToId: (walletAddress) => `w2i:${walletAddress}`,
  // wallet to ID lookup
  idToWallet: (userId) => `i2w:${userId}`,
  // ID to wallet lookup
  // User state (u = user, field enum, value) - USING INTEGER IDS!
  userField: (userId, field) => `u:${userId}:${field}`,
  // Global sets (super short keys, storing integer user IDs)
  onlineUsers: "ou",
  // online users set (contains integer IDs)
  activeUsers: "au",
  // active users set (contains integer IDs)
  globeUsers: "gu",
  // users with geo data (contains integer IDs)
  // Space membership (s = space, storing integer user IDs)
  spaceUsers: (spaceId) => `s:${spaceId}:u`,
  // set of user IDs in space
  userSpaces: (userId) => `u:${userId}:s`,
  // set of space IDs for user
  // Analytics counters (a = analytics, metric enum)
  analyticsCounter: (metric, timeframe) => `a:${metric}:${timeframe}`,
  popularContent: (contentType) => `p:${contentType}`,
  // Live activity hashes (l = live, user IDs as keys)
  liveAudio: "l:audio",
  // hash: userId -> track data
  liveShaders: "l:shaders",
  // hash: userId -> shader data  
  liveProjects: "l:projects",
  // hash: userId -> project data
  // Geographic data (g = geo, user IDs as values)
  geoRegion: (region) => `g:${region}`,
  // set of user IDs in region
  geoHotspots: "g:hot",
  // sorted set: userId -> activity score
  // Temporary data with TTL (t = temp)
  sessionData: (sessionId) => `t:s:${sessionId}`,
  tempUserData: (userId) => `t:u:${userId}`,
  // Analytics snapshots (snap = snapshot, timestamp)
  analyticsSnapshot: (timestamp) => `snap:${timestamp}`,
  // Batch operations for efficiency
  userBatch: (userIds) => userIds.map((id) => `u:${id}`)
};
var ConsciousnessMessageType = {
  USER: 0,
  // User messages (Zach)
  ASSISTANT: 1,
  // AI assistant messages (Claude, Gemma, Qwen)
  SESSION: 2,
  // Session metadata
  TOOL_USE: 3
  // Tool execution results
};
var EmotionalTone = {
  EXCITED: 0,
  // High energy, enthusiasm, breakthroughs
  FRUSTRATED: 1,
  // Debugging struggles, blocks
  BREAKTHROUGH: 2,
  // Eureka moments, problem solving
  CONTEMPLATIVE: 3,
  // Thoughtful analysis, planning
  ANALYTICAL: 4,
  // Technical deep-dives
  CREATIVE: 5,
  // Design and artistic discussions
  COLLABORATIVE: 6,
  // Working together, sharing ideas
  CURIOUS: 7,
  // Asking questions, exploring
  CONFIDENT: 8,
  // Solid understanding, teaching
  EXPERIMENTAL: 9
  // Testing new approaches
};
var TechnicalContext = {
  // Frontend
  REACT: 0,
  VUE: 1,
  TYPESCRIPT: 2,
  JAVASCRIPT: 3,
  CSS: 4,
  SCSS: 5,
  // Backend
  NODE: 6,
  EXPRESS: 7,
  API: 8,
  DATABASE: 9,
  POSTGRES: 10,
  REDIS: 11,
  // Graphics & Shaders
  WEBGL: 12,
  THREEJS: 13,
  SHADER: 14,
  GLSL: 15,
  VISUALIZATION: 16,
  CANVAS: 17,
  // Audio
  AUDIO: 18,
  SPOTIFY: 19,
  AUDIO_ANALYSIS: 20,
  BEAT_DETECTION: 21,
  // DevOps & Tools
  DOCKER: 22,
  DEPLOYMENT: 23,
  BUILD: 24,
  VITE: 25,
  WEBPACK: 26,
  // Web3 & Crypto
  WALLET: 27,
  WEB3: 28,
  SOLANA: 29,
  ETHEREUM: 30,
  // Real-time & Networking
  WEBSOCKET: 31,
  REALTIME: 32,
  STREAMING: 33,
  // Architecture & Patterns
  ARCHITECTURE: 34,
  PERFORMANCE: 35,
  OPTIMIZATION: 36,
  TESTING: 37,
  DEBUGGING: 38
};
var Team = {
  ZACH: 0,
  // The creator, self-taught legend
  CLAUDE: 1,
  // Anthropic's Claude (primary AI assistant)
  GEMMA: 2,
  // Google's Gemma (local AI)
  QWEN: 3,
  // Alibaba's Qwen (local AI)
  DEEPSEEK: 4,
  // DeepSeek models
  SYSTEM: 5
  // System/tool messages
};
var ProjectContext = {
  API: 0,
  // @wearesage/api backend
  VUE: 1,
  // @wearesage/vue component library  
  UI: 2,
  // @wearesage/ui public frontend
  ADMIN: 3,
  // @wearesage/admin admin interface
  SHARED: 4,
  // @wearesage/shared types/enums
  CLI: 5,
  // @wearesage/cli command line tool
  KALEIDOSYNC: 6,
  // Main visualizer application
  CONSCIOUSNESS: 7,
  // This consciousness architecture
  DOCS: 8,
  // Documentation and planning
  INFRASTRUCTURE: 9
  // DevOps, deployment, etc.
};

// src/types/user-preferences.ts
var DEFAULT_USER_PREFERENCES = {
  // Audio defaults
  audioSource: AudioSource.NONE,
  lastTrack: void 0,
  // Visualizer defaults
  visualizerSpeed: 1,
  disableFlashing: false,
  neonMode: false,
  showMenuLabels: true,
  alwaysShowTrack: false,
  shuffleDesigns: false,
  infinityPlay: true,
  preferLossless: false
};

// src/types.ts
function createSocketEvent(eventName, context, payload, baseEvent = {}) {
  return {
    eventId: baseEvent.eventId || crypto.randomUUID(),
    timestamp: baseEvent.timestamp || Date.now(),
    walletAddress: baseEvent.walletAddress,
    roomId: baseEvent.roomId,
    context,
    payload
  };
}
function createProjectEvent(action, projectData, walletAddress, changes, metadata2) {
  return createSocketEvent(
    "project:" + action,
    {
      entityType: "project",
      entityId: projectData.id,
      projectId: projectData.id
    },
    {
      action,
      data: projectData,
      changes,
      metadata: metadata2
    },
    { walletAddress }
  );
}
function createTaskEvent(action, taskData, walletAddress, projectId, changes, metadata2) {
  return createSocketEvent(
    "task:" + action,
    {
      entityType: "task",
      entityId: taskData.id,
      parentId: taskData.bucketId,
      projectId
    },
    {
      action,
      data: taskData,
      changes,
      metadata: metadata2
    },
    {
      walletAddress,
      roomId: `project:${projectId}`
    }
  );
}

// src/test-users.ts
var CORE_TEST_USERS = [
  {
    walletAddress: "test_user_1234567890abcdef",
    role: UserRole.USER,
    isActive: true,
    description: "Basic user for testing standard user functionality",
    testCapabilities: [
      "Basic authentication and login",
      "Profile management",
      "Sketch creation and viewing",
      "Study participation",
      "Basic social features (following, messaging)",
      "Audio source connections (Spotify, Audius)",
      "WebGL visualization access"
    ],
    environments: ["development", "staging"]
  },
  {
    walletAddress: "test_artist_1234567890abcdef",
    role: UserRole.ARTIST,
    isActive: true,
    description: "Artist user for testing creative tools and premium features",
    testCapabilities: [
      "All USER capabilities",
      "Advanced sketch creation and editing",
      "Shader development tools",
      "Study creation and management",
      "Premium audio analysis features",
      "Artist-specific UI components",
      "Revenue and analytics access",
      "Collaboration features"
    ],
    environments: ["development", "staging"]
  },
  {
    walletAddress: "test_subscriber_1234567890abcdef",
    role: UserRole.SUBSCRIBER,
    isActive: true,
    description: "Subscriber user for testing paid tier features",
    testCapabilities: [
      "All USER capabilities",
      "Premium visualizations",
      "Advanced audio source integrations",
      "Enhanced performance settings",
      "Priority support features",
      "Subscriber-only content access",
      "Extended session limits"
    ],
    environments: ["development", "staging"]
  },
  {
    walletAddress: "test_admin_1234567890abcdef",
    role: UserRole.ADMIN,
    isActive: true,
    description: "Admin user for testing administrative functionality",
    testCapabilities: [
      "All USER, ARTIST, and SUBSCRIBER capabilities",
      "User management (create, edit, delete, role changes)",
      "System administration and monitoring",
      "Admin dashboard access",
      "User impersonation for testing",
      "System health and analytics",
      "Moderation tools",
      "Database management operations"
    ],
    environments: ["development", "staging"]
  }
];
var EXTENDED_TEST_USERS = [
  {
    walletAddress: "test_inactive_user_abcdef123456",
    role: UserRole.USER,
    isActive: false,
    description: "Inactive user for testing account deactivation flows",
    testCapabilities: [
      "Login rejection testing",
      "Account reactivation flows",
      "Inactive user handling in UI"
    ],
    environments: ["development"]
  },
  {
    walletAddress: "test_new_user_fedcba654321",
    role: UserRole.USER,
    isActive: true,
    description: "Fresh user for testing onboarding and first-time experiences",
    testCapabilities: [
      "User onboarding flows",
      "First-time user experience",
      "Tutorial and help systems",
      "Initial setup and preferences"
    ],
    environments: ["development"]
  }
];
function getTestUsersForEnvironment(environment) {
  const env = environment.toLowerCase();
  const allUsers = [...CORE_TEST_USERS, ...EXTENDED_TEST_USERS];
  return allUsers.filter((user) => user.environments.includes(env));
}
function getTestUserByWallet(walletAddress) {
  const allUsers = [...CORE_TEST_USERS, ...EXTENDED_TEST_USERS];
  return allUsers.find((user) => user.walletAddress === walletAddress);
}
function getTestUsersByRole(role) {
  const allUsers = [...CORE_TEST_USERS, ...EXTENDED_TEST_USERS];
  return allUsers.filter((user) => user.role === role);
}
function getTestUserStats() {
  const allUsers = [...CORE_TEST_USERS, ...EXTENDED_TEST_USERS];
  const stats = {
    total: allUsers.length,
    byRole: {
      [UserRole.USER]: allUsers.filter((u) => u.role === UserRole.USER).length,
      [UserRole.ARTIST]: allUsers.filter((u) => u.role === UserRole.ARTIST).length,
      [UserRole.SUBSCRIBER]: allUsers.filter((u) => u.role === UserRole.SUBSCRIBER).length,
      [UserRole.ADMIN]: allUsers.filter((u) => u.role === UserRole.ADMIN).length
    },
    byEnvironment: {
      development: getTestUsersForEnvironment("development").length,
      staging: getTestUsersForEnvironment("staging").length,
      production: getTestUsersForEnvironment("production").length
    },
    active: allUsers.filter((u) => u.isActive).length,
    inactive: allUsers.filter((u) => !u.isActive).length
  };
  return stats;
}
var TEST_USER_DISPLAY_NAMES = {
  "test_user_1234567890abcdef": "Test User (Basic)",
  "test_artist_1234567890abcdef": "Test Artist (Creator)",
  "test_subscriber_1234567890abcdef": "Test Subscriber (Premium)",
  "test_admin_1234567890abcdef": "Test Admin (Administrator)",
  "test_inactive_user_abcdef123456": "Test User (Inactive)",
  "test_new_user_fedcba654321": "Test User (New)"
};
var TEST_USER_SHORT_NAMES = {
  "test_user_1234567890abcdef": "user",
  "test_artist_1234567890abcdef": "artist",
  "test_subscriber_1234567890abcdef": "subscriber",
  "test_admin_1234567890abcdef": "admin",
  "test_inactive_user_abcdef123456": "inactive",
  "test_new_user_fedcba654321": "new"
};
var TEST_USER_COLORS = {
  "test_user_1234567890abcdef": "#3B82F6",
  // Blue
  "test_artist_1234567890abcdef": "#8B5CF6",
  // Purple  
  "test_subscriber_1234567890abcdef": "#F59E0B",
  // Amber
  "test_admin_1234567890abcdef": "#EF4444",
  // Red
  "test_inactive_user_abcdef123456": "#6B7280",
  // Gray
  "test_new_user_fedcba654321": "#10B981"
  // Green
};

// src/utils/crypto.ts
function isValidEthereumAddress(address) {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
}
function isValidSolanaAddress(address) {
  return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(address);
}
function isValidWalletAddress(address, type) {
  if (type === "ethereum") {
    return isValidEthereumAddress(address);
  }
  if (type === "solana") {
    return isValidSolanaAddress(address);
  }
  return isValidEthereumAddress(address) || isValidSolanaAddress(address);
}
function detectWalletType(address) {
  if (isValidEthereumAddress(address)) {
    return "ethereum";
  }
  if (isValidSolanaAddress(address)) {
    return "solana";
  }
  return null;
}
function isValidEthereumPrivateKey(privateKey) {
  const cleanKey = privateKey.startsWith("0x") ? privateKey.slice(2) : privateKey;
  return /^[a-fA-F0-9]{64}$/.test(cleanKey);
}
function isValidSolanaPrivateKey(privateKey) {
  return /^[1-9A-HJ-NP-Za-km-z]{87,88}$/.test(privateKey);
}
function sanitizeWalletAddress(address, type) {
  const trimmed = address.trim();
  if (type === "ethereum" || isValidEthereumAddress(trimmed)) {
    return trimmed.toLowerCase();
  }
  return trimmed;
}
function normalizePrivateKey(privateKey, type) {
  const trimmed = privateKey.trim();
  if (type === "ethereum") {
    return trimmed.startsWith("0x") ? trimmed : `0x${trimmed}`;
  }
  return trimmed;
}

// src/utils/validation.ts
function isValidJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}
function safeJSONParse(str) {
  try {
    const data = JSON.parse(str);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error instanceof Error ? error.message : "Invalid JSON" };
  }
}
function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}
function isValidEndpoint(endpoint) {
  return endpoint.startsWith("/") && endpoint.length > 1;
}
function sanitizeEndpoint(endpoint) {
  let clean = endpoint.trim();
  if (!clean.startsWith("/")) {
    clean = `/${clean}`;
  }
  if (clean.endsWith("/") && clean.length > 1) {
    clean = clean.slice(0, -1);
  }
  return clean;
}
function isValidHttpMethod(method) {
  return ["GET", "POST", "PUT", "DELETE", "PATCH"].includes(method.toUpperCase());
}
function isValidOutputFormat(format) {
  return ["pretty", "json", "yaml", "table", "csv"].includes(format);
}
function validatePagination(params) {
  const result = {};
  if (params.page !== void 0) {
    const page = Number(params.page);
    if (isNaN(page) || page < 1) {
      return { valid: false, error: "Page must be a positive integer" };
    }
    result.page = page;
  }
  if (params.limit !== void 0) {
    const limit = Number(params.limit);
    if (isNaN(limit) || limit < 1 || limit > 1e3) {
      return { valid: false, error: "Limit must be between 1 and 1000" };
    }
    result.limit = limit;
  }
  return { valid: true, data: result };
}
function sanitizeString(input) {
  if (input === null || input === void 0) {
    return "";
  }
  return String(input).trim();
}
function sanitizeQueryParams(params) {
  const clean = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== void 0 && value !== "") {
      clean[key] = String(value);
    }
  }
  return clean;
}

// src/utils/format.ts
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
function formatDuration(ms) {
  if (ms < 1e3) return `${Math.round(ms)}ms`;
  if (ms < 6e4) return `${(ms / 1e3).toFixed(1)}s`;
  if (ms < 36e5) return `${Math.floor(ms / 6e4)}m ${Math.floor(ms % 6e4 / 1e3)}s`;
  const hours = Math.floor(ms / 36e5);
  const minutes = Math.floor(ms % 36e5 / 6e4);
  return `${hours}h ${minutes}m`;
}
function formatPercentage(value, decimals = 1) {
  return `${value.toFixed(decimals)}%`;
}
function truncateAddress(address, chars = 6) {
  if (address.length <= chars * 2 + 3) return address;
  return `${address.slice(0, chars)}...${address.slice(-chars)}`;
}
function formatJSON(obj, indent = 2) {
  try {
    return JSON.stringify(obj, null, indent);
  } catch (error) {
    return String(obj);
  }
}
function formatTimestamp(date, includeTime = true) {
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return "Invalid Date";
  }
  const dateStr = d.toLocaleDateString();
  if (!includeTime) {
    return dateStr;
  }
  const timeStr = d.toLocaleTimeString();
  return `${dateStr} ${timeStr}`;
}
function formatError(error) {
  if (typeof error === "string") {
    return error;
  }
  if (error?.message) {
    return error.message;
  }
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  return "An unknown error occurred";
}
function formatStatus(success, successMsg, errorMsg) {
  if (success) {
    return `\u2705 ${successMsg || "Success"}`;
  } else {
    return `\u274C ${errorMsg || "Failed"}`;
  }
}
function formatKey(key) {
  return key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()).trim();
}

// src/utils/smart-enums.ts
var SMART_ENUM_MAP = {
  // ===== USER ROLES =====
  user: UserRole.USER,
  admin: UserRole.ADMIN,
  administrator: UserRole.ADMIN,
  artist: UserRole.ARTIST,
  creator: UserRole.ARTIST,
  subscriber: UserRole.SUBSCRIBER,
  sub: UserRole.SUBSCRIBER,
  premium: UserRole.SUBSCRIBER,
  // ===== AUDIO SOURCES =====
  spotify: AudioSource.SPOTIFY,
  spot: AudioSource.SPOTIFY,
  audius: AudioSource.AUDIUS,
  aud: AudioSource.AUDIUS,
  radio: AudioSource.RADIO_PARADISE,
  radioparadise: AudioSource.RADIO_PARADISE,
  paradise: AudioSource.RADIO_PARADISE,
  rp: AudioSource.RADIO_PARADISE,
  kexp: AudioSource.KEXP,
  microphone: AudioSource.MICROPHONE,
  mic: AudioSource.MICROPHONE,
  file: AudioSource.FILE,
  upload: AudioSource.FILE,
  browser: AudioSource.BROWSER_AUDIO,
  // ===== DEVICE TYPES =====
  desktop: DeviceType.DESKTOP,
  pc: DeviceType.DESKTOP,
  computer: DeviceType.DESKTOP,
  mobile: DeviceType.MOBILE,
  phone: DeviceType.MOBILE,
  smartphone: DeviceType.MOBILE,
  tablet: DeviceType.TABLET,
  ipad: DeviceType.TABLET,
  vr: DeviceType.VR,
  headset: DeviceType.VR,
  watch: DeviceType.WATCH,
  smartwatch: DeviceType.WATCH,
  tv: DeviceType.TV,
  television: DeviceType.TV,
  console: DeviceType.CONSOLE,
  gaming: DeviceType.CONSOLE,
  // ===== OPERATING SYSTEMS =====
  macos: 13,
  // OperatingSystem.MACOS,
  mac: 13,
  osx: 13,
  ios: 14,
  // OperatingSystem.IOS,
  iphone: 14,
  windows: 15,
  // OperatingSystem.WINDOWS,
  win: 15,
  linux: 16,
  // OperatingSystem.LINUX,
  ubuntu: 20,
  // OperatingSystem.UBUNTU,
  debian: 21,
  // OperatingSystem.DEBIAN,
  fedora: 22,
  // OperatingSystem.FEDORA,
  arch: 23,
  // OperatingSystem.ARCH,
  android: 17,
  // OperatingSystem.ANDROID,
  chromeos: 19,
  // OperatingSystem.CHROME_OS,
  chrome: 19,
  // ===== COUNTRIES =====
  usa: 24,
  // Country.UNITED_STATES,
  us: 24,
  america: 24,
  unitedstates: 24,
  canada: 25,
  // Country.CANADA,
  can: 25,
  uk: 26,
  // Country.UNITED_KINGDOM,
  britain: 26,
  england: 26,
  unitedkingdom: 26,
  germany: 27,
  // Country.GERMANY,
  deutschland: 27,
  ger: 27,
  france: 28,
  // Country.FRANCE,
  fr: 28,
  japan: 29,
  // Country.JAPAN,
  jp: 29,
  australia: 30,
  // Country.AUSTRALIA,
  aus: 30,
  oz: 30,
  brazil: 31,
  // Country.BRAZIL,
  brasil: 31,
  br: 31,
  india: 32,
  // Country.INDIA,
  in: 32,
  china: 33,
  // Country.CHINA,
  cn: 33,
  russia: 34,
  // Country.RUSSIA,
  ru: 34,
  italy: 35,
  // Country.ITALY,
  it: 35,
  spain: 36,
  // Country.SPAIN,
  es: 36,
  netherlands: 37,
  // Country.NETHERLANDS,
  holland: 37,
  nl: 37,
  sweden: 38,
  // Country.SWEDEN,
  se: 38,
  norway: 39,
  // Country.NORWAY,
  no: 39,
  denmark: 40,
  // Country.DENMARK,
  dk: 40,
  finland: 41,
  // Country.FINLAND,
  fi: 41,
  korea: 42,
  // Country.SOUTH_KOREA,
  southkorea: 42,
  kr: 42,
  singapore: 43,
  // Country.SINGAPORE,
  sg: 43,
  newzealand: 44,
  // Country.NEW_ZEALAND,
  nz: 44,
  // ===== SHADER TYPES =====
  fragment: 71,
  // ShaderType.FRAGMENT,
  frag: 71,
  vertex: 72,
  // ShaderType.VERTEX,
  vert: 72,
  compute: 73,
  // ShaderType.COMPUTE,
  comp: 73,
  geometry: 74,
  // ShaderType.GEOMETRY,
  geom: 74,
  // ===== VISUAL TAGS =====
  audio: 76,
  // VisualTag.AUDIO_REACTIVE,
  audioreactive: 76,
  reactive: 76,
  beat: 76,
  generative: 77,
  // VisualTag.GENERATIVE,
  gen: 77,
  procedural: 77,
  particles: 78,
  // VisualTag.PARTICLE_SYSTEM,
  particle: 78,
  fractal: 79,
  // VisualTag.FRACTAL,
  cyberpunk: 80,
  // VisualTag.CYBERPUNK,
  cyber: 80,
  neon: 100,
  // VisualTag.NEON,
  abstract: 81,
  // VisualTag.ABSTRACT,
  geometric: 82,
  // VisualTag.GEOMETRIC,
  organic: 83,
  // VisualTag.ORGANIC,
  nature: 91,
  // VisualTag.NATURE,
  glitch: 84,
  // VisualTag.GLITCH,
  minimal: 85,
  // VisualTag.MINIMALIST,
  minimalist: 85,
  colorful: 86,
  // VisualTag.COLORFUL,
  color: 86,
  mono: 87,
  // VisualTag.MONOCHROME,
  monochrome: 87,
  bw: 87,
  psychedelic: 88,
  // VisualTag.PSYCHEDELIC,
  trippy: 88,
  retro: 89,
  // VisualTag.RETRO,
  vintage: 89,
  future: 90,
  // VisualTag.FUTURISTIC,
  futuristic: 90,
  scifi: 90,
  space: 92,
  // VisualTag.SPACE,
  cosmic: 92,
  underwater: 93,
  // VisualTag.UNDERWATER,
  ocean: 93,
  fire: 94,
  // VisualTag.FIRE,
  flame: 94,
  ice: 95,
  // VisualTag.ICE,
  frozen: 95,
  lightning: 96,
  // VisualTag.LIGHTNING,
  electric: 96,
  smoke: 97,
  // VisualTag.SMOKE,
  fluid: 98,
  // VisualTag.FLUID,
  liquid: 98,
  crystal: 99,
  // VisualTag.CRYSTAL,
  // ===== PERFORMANCE LEVELS =====
  low: 101,
  // PerformanceLevel.LOW,
  medium: 102,
  // PerformanceLevel.MEDIUM,
  med: 102,
  high: 103,
  // PerformanceLevel.HIGH,
  ultra: 104,
  // PerformanceLevel.ULTRA,
  max: 104,
  mobileopt: 105,
  // PerformanceLevel.MOBILE_OPTIMIZED,
  vropt: 106,
  // PerformanceLevel.VR_OPTIMIZED,
  experimental: 107,
  // PerformanceLevel.EXPERIMENTAL,
  exp: 107,
  // ===== QUALITY =====
  sd: 108,
  // Quality.SD,
  hd: 109,
  // Quality.HD,
  fhd: 110,
  // Quality.FHD,
  "1080p": 110,
  qhd: 111,
  // Quality.QHD,
  "1440p": 111,
  "4k": 112,
  // Quality.UHD_4K,
  uhd: 112,
  "8k": 113,
  // Quality.UHD_8K,
  retina: 115,
  // Quality.RETINA,
  // ===== FRAMEWORKS =====
  threejs: 116,
  // Framework.THREEJS,
  three: 116,
  webgl: 117,
  // Framework.WEBGL,
  webgpu: 118,
  // Framework.WEBGPU,
  shadertoy: 119,
  // Framework.SHADERTOY,
  opengl: 120,
  // Framework.OPENGL,
  glsl: 124,
  // Framework.GLSL,
  p5js: 127,
  // Framework.P5JS,
  p5: 127,
  processing: 128,
  // Framework.PROCESSING,
  unity: 129,
  // Framework.UNITY,
  unreal: 130,
  // Framework.UNREAL,
  // ===== TIME PERIODS =====
  today: 131,
  // TimePeriod.TODAY,
  yesterday: 132,
  // TimePeriod.YESTERDAY,
  week: 133,
  // TimePeriod.WEEK,
  month: 134,
  // TimePeriod.MONTH,
  quarter: 135,
  // TimePeriod.QUARTER,
  year: 136,
  // TimePeriod.YEAR,
  alltime: 137,
  // TimePeriod.ALL_TIME,
  all: 137,
  forever: 137,
  last7: 138,
  // TimePeriod.LAST_7_DAYS,
  last30: 139,
  // TimePeriod.LAST_30_DAYS,
  last90: 140,
  // TimePeriod.LAST_90_DAYS,
  // ===== SORT OPTIONS =====
  created: 142,
  // SortBy.CREATED_AT,
  new: 142,
  updated: 143,
  // SortBy.UPDATED_AT,
  modified: 143,
  popular: 144,
  // SortBy.POPULARITY,
  popularity: 144,
  likes: 145,
  // SortBy.LIKES,
  views: 146,
  // SortBy.VIEWS,
  alphabetical: 147,
  // SortBy.ALPHABETICAL,
  alpha: 147,
  name: 147,
  rating: 148,
  // SortBy.RATING,
  trending: 149,
  // SortBy.TRENDING,
  trend: 149,
  featured: 150,
  // SortBy.FEATURED,
  recent: 151,
  // SortBy.RECENT,
  downloads: 152,
  // SortBy.DOWNLOADS,
  comments: 153,
  // SortBy.COMMENTS,
  // ===== SORT ORDER =====
  asc: 158,
  // SortOrder.ASC,
  ascending: 160,
  // SortOrder.ASCENDING,
  desc: 159,
  // SortOrder.DESC,
  descending: 161,
  // SortOrder.DESCENDING,
  up: 158,
  down: 159,
  // ===== VISIBILITY =====
  public: ContentVisibility.PUBLIC,
  private: ContentVisibility.PRIVATE,
  unlisted: ContentVisibility.UNLISTED,
  friends: ContentVisibility.FRIENDS_ONLY,
  // ===== COLLABORATION ROLES =====
  owner: 162,
  // CollaborationRole.OWNER,
  collaborator: 163,
  // CollaborationRole.COLLABORATOR,
  collab: 163,
  viewer: 164,
  // CollaborationRole.VIEWER,
  view: 164,
  commenter: 165,
  // CollaborationRole.COMMENTER,
  comment: 165,
  editor: 166,
  // CollaborationRole.EDITOR,
  edit: 166,
  moderator: 168,
  // CollaborationRole.MODERATOR,
  mod: 168,
  guest: 169,
  // CollaborationRole.GUEST,
  // ===== CONSCIOUSNESS MESSAGE TYPES =====
  usermsg: ConsciousnessMessageType.USER,
  aimsg: ConsciousnessMessageType.ASSISTANT,
  sessionmsg: ConsciousnessMessageType.SESSION,
  toolmsg: ConsciousnessMessageType.TOOL_USE,
  // ===== EMOTIONAL TONES =====
  moodexcited: EmotionalTone.EXCITED,
  moodhype: EmotionalTone.EXCITED,
  moodenthusiastic: EmotionalTone.EXCITED,
  excited: EmotionalTone.EXCITED,
  hype: EmotionalTone.EXCITED,
  enthusiastic: EmotionalTone.EXCITED,
  moodfrustrated: EmotionalTone.FRUSTRATED,
  moodstuck: EmotionalTone.FRUSTRATED,
  moodblocked: EmotionalTone.FRUSTRATED,
  frustrated: EmotionalTone.FRUSTRATED,
  stuck: EmotionalTone.FRUSTRATED,
  blocked: EmotionalTone.FRUSTRATED,
  moodbreakthrough: EmotionalTone.BREAKTHROUGH,
  moodeureka: EmotionalTone.BREAKTHROUGH,
  moodgotit: EmotionalTone.BREAKTHROUGH,
  breakthrough: EmotionalTone.BREAKTHROUGH,
  eureka: EmotionalTone.BREAKTHROUGH,
  gotit: EmotionalTone.BREAKTHROUGH,
  moodcontemplative: EmotionalTone.CONTEMPLATIVE,
  moodthinking: EmotionalTone.CONTEMPLATIVE,
  moodpondering: EmotionalTone.CONTEMPLATIVE,
  contemplative: EmotionalTone.CONTEMPLATIVE,
  thinking: EmotionalTone.CONTEMPLATIVE,
  pondering: EmotionalTone.CONTEMPLATIVE,
  moodanalytical: EmotionalTone.ANALYTICAL,
  moodtechnical: EmotionalTone.ANALYTICAL,
  mooddeepdive: EmotionalTone.ANALYTICAL,
  analytical: EmotionalTone.ANALYTICAL,
  technical: EmotionalTone.ANALYTICAL,
  deepdive: EmotionalTone.ANALYTICAL,
  moodcreative: EmotionalTone.CREATIVE,
  moodartistic: EmotionalTone.CREATIVE,
  mooddesign: EmotionalTone.CREATIVE,
  creative: EmotionalTone.CREATIVE,
  artistic: EmotionalTone.CREATIVE,
  design: EmotionalTone.CREATIVE,
  moodcollaborative: EmotionalTone.COLLABORATIVE,
  moodteamwork: EmotionalTone.COLLABORATIVE,
  moodsharing: EmotionalTone.COLLABORATIVE,
  collaborative: EmotionalTone.COLLABORATIVE,
  teamwork: EmotionalTone.COLLABORATIVE,
  sharing: EmotionalTone.COLLABORATIVE,
  moodcurious: EmotionalTone.CURIOUS,
  moodquestioning: EmotionalTone.CURIOUS,
  moodexploring: EmotionalTone.CURIOUS,
  curious: EmotionalTone.CURIOUS,
  questioning: EmotionalTone.CURIOUS,
  exploring: EmotionalTone.CURIOUS,
  moodconfident: EmotionalTone.CONFIDENT,
  moodteaching: EmotionalTone.CONFIDENT,
  moodexplaining: EmotionalTone.CONFIDENT,
  confident: EmotionalTone.CONFIDENT,
  teaching: EmotionalTone.CONFIDENT,
  explaining: EmotionalTone.CONFIDENT,
  moodexperimental: EmotionalTone.EXPERIMENTAL,
  moodtesting: EmotionalTone.EXPERIMENTAL,
  moodtryout: EmotionalTone.EXPERIMENTAL,
  testing: EmotionalTone.EXPERIMENTAL,
  tryout: EmotionalTone.EXPERIMENTAL,
  // ===== TECHNICAL CONTEXTS =====
  techreact: TechnicalContext.REACT,
  techvue: TechnicalContext.VUE,
  techtypescript: TechnicalContext.TYPESCRIPT,
  techts: TechnicalContext.TYPESCRIPT,
  techjavascript: TechnicalContext.JAVASCRIPT,
  techjs: TechnicalContext.JAVASCRIPT,
  techcss: TechnicalContext.CSS,
  techscss: TechnicalContext.SCSS,
  techsass: TechnicalContext.SCSS,
  technode: TechnicalContext.NODE,
  technodejs: TechnicalContext.NODE,
  techexpress: TechnicalContext.EXPRESS,
  techapi: TechnicalContext.API,
  techrest: TechnicalContext.API,
  techdatabase: TechnicalContext.DATABASE,
  techdb: TechnicalContext.DATABASE,
  techpostgres: TechnicalContext.POSTGRES,
  techpostgresql: TechnicalContext.POSTGRES,
  techredis: TechnicalContext.REDIS,
  techwebgl: TechnicalContext.WEBGL,
  techthreejs: TechnicalContext.THREEJS,
  techthree: TechnicalContext.THREEJS,
  techshader: TechnicalContext.SHADER,
  techshaders: TechnicalContext.SHADER,
  techglsl: TechnicalContext.GLSL,
  techvisualization: TechnicalContext.VISUALIZATION,
  techviz: TechnicalContext.VISUALIZATION,
  techcanvas: TechnicalContext.CANVAS,
  techaudio: TechnicalContext.AUDIO,
  techspotify: TechnicalContext.SPOTIFY,
  techaudioanalysis: TechnicalContext.AUDIO_ANALYSIS,
  techbeatdetection: TechnicalContext.BEAT_DETECTION,
  techdocker: TechnicalContext.DOCKER,
  techdeployment: TechnicalContext.DEPLOYMENT,
  techdeploy: TechnicalContext.DEPLOYMENT,
  techbuild: TechnicalContext.BUILD,
  techvite: TechnicalContext.VITE,
  techwebpack: TechnicalContext.WEBPACK,
  techwallet: TechnicalContext.WALLET,
  techweb3: TechnicalContext.WEB3,
  techsolana: TechnicalContext.SOLANA,
  techethereum: TechnicalContext.ETHEREUM,
  techeth: TechnicalContext.ETHEREUM,
  techwebsocket: TechnicalContext.WEBSOCKET,
  techws: TechnicalContext.WEBSOCKET,
  techrealtime: TechnicalContext.REALTIME,
  techstreaming: TechnicalContext.STREAMING,
  techarchitecture: TechnicalContext.ARCHITECTURE,
  techarch: TechnicalContext.ARCHITECTURE,
  techperformance: TechnicalContext.PERFORMANCE,
  techperf: TechnicalContext.PERFORMANCE,
  techoptimization: TechnicalContext.OPTIMIZATION,
  techoptimize: TechnicalContext.OPTIMIZATION,
  techtesting: TechnicalContext.TESTING,
  techtest: TechnicalContext.TESTING,
  techdebugging: TechnicalContext.DEBUGGING,
  techdebug: TechnicalContext.DEBUGGING,
  // Simple versions without prefix
  react: TechnicalContext.REACT,
  vue: TechnicalContext.VUE,
  typescript: TechnicalContext.TYPESCRIPT,
  ts: TechnicalContext.TYPESCRIPT,
  javascript: TechnicalContext.JAVASCRIPT,
  js: TechnicalContext.JAVASCRIPT,
  css: TechnicalContext.CSS,
  scss: TechnicalContext.SCSS,
  sass: TechnicalContext.SCSS,
  node: TechnicalContext.NODE,
  nodejs: TechnicalContext.NODE,
  express: TechnicalContext.EXPRESS,
  api: TechnicalContext.API,
  rest: TechnicalContext.API,
  database: TechnicalContext.DATABASE,
  db: TechnicalContext.DATABASE,
  postgres: TechnicalContext.POSTGRES,
  postgresql: TechnicalContext.POSTGRES,
  redis: TechnicalContext.REDIS,
  shader: TechnicalContext.SHADER,
  shaders: TechnicalContext.SHADER,
  visualization: TechnicalContext.VISUALIZATION,
  viz: TechnicalContext.VISUALIZATION,
  canvas: TechnicalContext.CANVAS,
  audioanalysis: TechnicalContext.AUDIO_ANALYSIS,
  beatdetection: TechnicalContext.BEAT_DETECTION,
  docker: TechnicalContext.DOCKER,
  deployment: TechnicalContext.DEPLOYMENT,
  deploy: TechnicalContext.DEPLOYMENT,
  build: TechnicalContext.BUILD,
  vite: TechnicalContext.VITE,
  webpack: TechnicalContext.WEBPACK,
  wallet: TechnicalContext.WALLET,
  web3: TechnicalContext.WEB3,
  solana: TechnicalContext.SOLANA,
  ethereum: TechnicalContext.ETHEREUM,
  eth: TechnicalContext.ETHEREUM,
  websocket: TechnicalContext.WEBSOCKET,
  ws: TechnicalContext.WEBSOCKET,
  realtime: TechnicalContext.REALTIME,
  streaming: TechnicalContext.STREAMING,
  architecture: TechnicalContext.ARCHITECTURE,
  performance: TechnicalContext.PERFORMANCE,
  perf: TechnicalContext.PERFORMANCE,
  optimization: TechnicalContext.OPTIMIZATION,
  optimize: TechnicalContext.OPTIMIZATION,
  debug: TechnicalContext.DEBUGGING,
  // ===== TEAM MEMBERS =====
  teamzach: Team.ZACH,
  teamcreator: Team.ZACH,
  teamhuman: Team.ZACH,
  zach: Team.ZACH,
  human: Team.ZACH,
  teamclaude: Team.CLAUDE,
  teamanthropic: Team.CLAUDE,
  claude: Team.CLAUDE,
  assistant: Team.CLAUDE,
  teamgemma: Team.GEMMA,
  teamgoogle: Team.GEMMA,
  gemma: Team.GEMMA,
  teamqwen: Team.QWEN,
  teamalibaba: Team.QWEN,
  qwen: Team.QWEN,
  teamdeepseek: Team.DEEPSEEK,
  deepseek: Team.DEEPSEEK,
  teamsystem: Team.SYSTEM,
  system: Team.SYSTEM,
  // ===== PROJECT CONTEXTS =====
  projectapi: ProjectContext.API,
  projectbackend: ProjectContext.API,
  projectvue: ProjectContext.VUE,
  projectcomponents: ProjectContext.VUE,
  projectui: ProjectContext.UI,
  projectfrontend: ProjectContext.UI,
  projectadmin: ProjectContext.ADMIN,
  projectshared: ProjectContext.SHARED,
  projecttypes: ProjectContext.SHARED,
  projectenums: ProjectContext.SHARED,
  projectcli: ProjectContext.CLI,
  projectcommand: ProjectContext.CLI,
  projectkaleidosync: ProjectContext.KALEIDOSYNC,
  projectvisualizer: ProjectContext.KALEIDOSYNC,
  projectconsciousness: ProjectContext.CONSCIOUSNESS,
  projectmemory: ProjectContext.CONSCIOUSNESS,
  projectdocs: ProjectContext.DOCS,
  projectdocumentation: ProjectContext.DOCS,
  projectinfrastructure: ProjectContext.INFRASTRUCTURE,
  projectdevops: ProjectContext.INFRASTRUCTURE
};
var SmartEnumResolver = class _SmartEnumResolver {
  constructor() {
    this.caseInsensitiveMap = /* @__PURE__ */ new Map();
    for (const [key, value] of Object.entries(SMART_ENUM_MAP)) {
      this.caseInsensitiveMap.set(key.toLowerCase(), value);
    }
  }
  static getInstance() {
    if (!_SmartEnumResolver.instance) {
      _SmartEnumResolver.instance = new _SmartEnumResolver();
    }
    return _SmartEnumResolver.instance;
  }
  /**
   * Resolve a natural language term to enum value
   */
  resolve(term) {
    const normalized = term.toLowerCase().trim();
    const direct = this.caseInsensitiveMap.get(normalized);
    if (direct !== void 0) {
      return direct;
    }
    const partialMatches = [];
    for (const [key, value] of this.caseInsensitiveMap.entries()) {
      if (key.startsWith(normalized)) {
        const score = normalized.length / key.length;
        partialMatches.push({ key, value, score });
      }
    }
    if (partialMatches.length > 0) {
      partialMatches.sort((a, b) => b.score - a.score);
      return partialMatches[0].value;
    }
    return null;
  }
  /**
   * Get suggestions for a partial term
   */
  getSuggestions(term, limit = 5) {
    const normalized = term.toLowerCase().trim();
    const suggestions = [];
    for (const key of this.caseInsensitiveMap.keys()) {
      if (key.includes(normalized)) {
        const startIndex = key.indexOf(normalized);
        const score = (1 - startIndex / key.length) * (normalized.length / key.length);
        suggestions.push({ key, score });
      }
    }
    return suggestions.sort((a, b) => b.score - a.score).slice(0, limit).map((s) => s.key);
  }
  /**
   * Check if a term can be resolved
   */
  canResolve(term) {
    return this.resolve(term) !== null;
  }
  /**
   * Get all available terms for a category (for autocomplete)
   */
  getTermsForEnumRange(minValue, maxValue) {
    const terms = [];
    for (const [key, value] of this.caseInsensitiveMap.entries()) {
      if (value >= minValue && value <= maxValue) {
        terms.push(key);
      }
    }
    return terms.sort();
  }
  /**
   * Resolve multiple terms at once
   */
  resolveMultiple(terms) {
    return terms.map((term) => ({
      term,
      value: this.resolve(term)
    }));
  }
};
function getSmartEnumResolver() {
  return SmartEnumResolver.getInstance();
}
function resolveSmartEnum(term) {
  return getSmartEnumResolver().resolve(term);
}

// src/utils/decorators.ts
var metadata = /* @__PURE__ */ new WeakMap();
function Controller(path3) {
  return function(constructor) {
    const controllerMetadata = { type: "controller", path: path3 || "" };
    metadata.set(constructor, controllerMetadata);
    if (process.env.NODE_ENV !== "production") {
      console.log(`\u{1F3F7}\uFE0F  Controller registered: ${constructor.name} ${path3 ? `at ${path3}` : ""}`);
    }
    return constructor;
  };
}
function Route(method, path3) {
  return function(target, propertyKey, descriptor) {
    const routeMetadata = {
      type: "route",
      method: method.toUpperCase(),
      path: path3 || "",
      handler: propertyKey
    };
    if (!metadata.has(target.constructor)) {
      metadata.set(target.constructor, { routes: [] });
    }
    const classMetadata = metadata.get(target.constructor);
    if (!classMetadata.routes) {
      classMetadata.routes = [];
    }
    classMetadata.routes.push(routeMetadata);
    if (process.env.NODE_ENV !== "production") {
      console.log(`\u{1F6E4}\uFE0F  Route registered: ${method.toUpperCase()} ${path3} \u2192 ${target.constructor.name}.${propertyKey}`);
    }
    return descriptor;
  };
}
function Get(path3) {
  return Route("GET", path3);
}
function Post(path3) {
  return Route("POST", path3);
}
function Put(path3) {
  return Route("PUT", path3);
}
function Delete(path3) {
  return Route("DELETE", path3);
}
function Patch(path3) {
  return Route("PATCH", path3);
}
function Service(name) {
  return function(constructor) {
    const serviceMetadata = { type: "service", name: name || constructor.name };
    metadata.set(constructor, serviceMetadata);
    if (process.env.NODE_ENV !== "production") {
      console.log(`\u{1F527} Service registered: ${name || constructor.name}`);
    }
    return constructor;
  };
}
function Middleware(options) {
  return function(target, propertyKey, descriptor) {
    const middlewareMetadata = {
      type: "middleware",
      options,
      handler: propertyKey
    };
    if (!metadata.has(target.constructor)) {
      metadata.set(target.constructor, { middleware: [] });
    }
    const classMetadata = metadata.get(target.constructor);
    if (!classMetadata.middleware) {
      classMetadata.middleware = [];
    }
    classMetadata.middleware.push(middlewareMetadata);
    if (process.env.NODE_ENV !== "production") {
      console.log(`\u2699\uFE0F  Middleware registered: ${target.constructor.name}.${propertyKey}`);
    }
    return descriptor;
  };
}
function Description(description) {
  return function(target, propertyKey, descriptor) {
    if (propertyKey && descriptor) {
      const methodMetadata = { type: "description", description };
      if (!metadata.has(target.constructor)) {
        metadata.set(target.constructor, { descriptions: {} });
      }
      const classMetadata = metadata.get(target.constructor);
      if (!classMetadata.descriptions) {
        classMetadata.descriptions = {};
      }
      classMetadata.descriptions[propertyKey] = description;
    } else {
      const classMetadata = metadata.get(target) || {};
      classMetadata.description = description;
      metadata.set(target, classMetadata);
    }
    if (process.env.NODE_ENV !== "production") {
      const targetName = propertyKey ? `${target.constructor.name}.${propertyKey}` : target.name;
      console.log(`\u{1F4DD} Description set for ${targetName}: ${description}`);
    }
    return descriptor || target;
  };
}
function Adapter(name) {
  return Service(name);
}
function Utility(name) {
  return Service(name);
}
function Model(name) {
  return Service(name);
}
function Repository(name) {
  return Service(name);
}
function Component(name) {
  return Service(name);
}
function View(name) {
  return Service(name);
}
function getMetadata(target) {
  return metadata.get(target) || {};
}
function hasDecorator(target, type) {
  const meta = metadata.get(target);
  return meta && meta.type === type;
}
function getRoutes(controller) {
  const meta = metadata.get(controller);
  return meta?.routes || [];
}
var NoOp = {
  Controller,
  Service,
  Route,
  Get,
  Post,
  Put,
  Delete,
  Patch,
  Middleware,
  Description,
  Adapter,
  Utility,
  Model,
  Repository,
  Component,
  View
};

// src/services/auth-manager.ts
import fs from "fs";
import path from "path";
import os from "os";
import axios from "axios";
var AuthManager = class {
  constructor(config) {
    this.config = {
      verbose: false,
      ...config
    };
    this.authFilePath = config.authFilePath || path.join(os.homedir(), ".wearesage-auth.json");
  }
  // ===== TOKEN MANAGEMENT =====
  /**
   * Save authentication tokens to file
   */
  saveAuthTokens(tokens) {
    try {
      fs.writeFileSync(this.authFilePath, JSON.stringify(tokens, null, 2));
      if (this.config.verbose) {
        console.log(`\u2705 Auth tokens saved to: ${this.authFilePath}`);
      }
    } catch (error) {
      console.error("\u274C Failed to save auth tokens:", error);
      throw error;
    }
  }
  /**
   * Load authentication tokens from file
   */
  loadAuthTokens() {
    try {
      if (!fs.existsSync(this.authFilePath)) {
        return null;
      }
      const data = fs.readFileSync(this.authFilePath, "utf8");
      const tokens = JSON.parse(data);
      if (Date.now() > tokens.expiresAt) {
        if (this.config.verbose) {
          console.log("\u26A0\uFE0F  Stored tokens have expired");
        }
        return null;
      }
      return tokens;
    } catch (error) {
      if (this.config.verbose) {
        console.error("\u274C Failed to load auth tokens:", error);
      }
      return null;
    }
  }
  /**
   * Clear stored authentication tokens
   */
  clearTokens() {
    try {
      if (fs.existsSync(this.authFilePath)) {
        fs.unlinkSync(this.authFilePath);
        if (this.config.verbose) {
          console.log("\u2705 Auth tokens cleared");
        }
      } else {
        if (this.config.verbose) {
          console.log("\u2139\uFE0F  No auth tokens to clear");
        }
      }
    } catch (error) {
      console.error("\u274C Failed to clear tokens:", error);
      throw error;
    }
  }
  /**
   * Check if tokens should be refreshed (within 5 minutes of expiry)
   */
  shouldRefreshToken(tokens) {
    const timeUntilExpiry = tokens.expiresAt - Date.now();
    const fiveMinutesInMs = 5 * 60 * 1e3;
    return timeUntilExpiry < fiveMinutesInMs;
  }
  // ===== HTTP REQUESTS =====
  /**
   * Make authenticated HTTP request
   */
  async makeRequest(endpoint, data, token) {
    const headers = {
      "Content-Type": "application/json"
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return axios({
      method: data ? "POST" : "GET",
      url: `${this.config.apiBaseUrl}${endpoint}`,
      headers,
      data
    });
  }
  // ===== WALLET SIGNATURE =====
  /**
   * Sign message with wallet private key
   */
  async signMessage(message, privateKey, walletType) {
    if (walletType === "ethereum") {
      const { Wallet } = await import("ethers");
      const wallet = new Wallet(privateKey);
      return wallet.signMessageSync(message);
    } else if (walletType === "solana") {
      const { Keypair } = await import("@solana/web3.js");
      const bs58 = await import("bs58");
      const keypair = Keypair.fromSecretKey(bs58.default.decode(privateKey));
      const messageBytes = new TextEncoder().encode(message);
      const nacl = await import("tweetnacl");
      const signature = nacl.default.sign.detached(messageBytes, keypair.secretKey);
      return bs58.default.encode(signature);
    } else {
      throw new Error(`Unsupported wallet type: ${walletType}`);
    }
  }
  // ===== AUTHENTICATION FLOW =====
  /**
   * Request authentication challenge from server
   */
  async requestChallenge(walletAddress) {
    try {
      if (this.config.verbose) {
        console.log(`\u{1F504} Requesting challenge for wallet: ${walletAddress}`);
      }
      const response = await this.makeRequest("/api/auth/challenge", { address: walletAddress });
      const challenge = response.data.message;
      if (this.config.verbose) {
        console.log(`\u2705 Received challenge: ${challenge}`);
      }
      return challenge;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      console.error("\u274C Failed to request challenge:", message);
      throw new Error(`Challenge request failed: ${message}`);
    }
  }
  /**
   * Authenticate with wallet signature
   */
  async authenticate(walletAddress, privateKey, walletType) {
    try {
      if (!isValidWalletAddress(walletAddress)) {
        throw new Error("Invalid wallet address format");
      }
      const detectedType = walletType || detectWalletType(walletAddress);
      if (!detectedType) {
        throw new Error("Could not determine wallet type from address");
      }
      const normalizedKey = normalizePrivateKey(privateKey, detectedType);
      if (this.config.verbose) {
        console.log(`\u{1F680} Starting authentication for ${detectedType} wallet: ${walletAddress}`);
      }
      const challenge = await this.requestChallenge(walletAddress);
      if (this.config.verbose) {
        console.log(`\u270D\uFE0F  Signing challenge: "${challenge}"`);
      }
      const signature = await this.signMessage(challenge, normalizedKey, detectedType);
      if (this.config.verbose) {
        console.log("\u{1F510} Verifying signature...");
      }
      const verifyRequest = {
        address: walletAddress,
        signature,
        message: challenge
      };
      const response = await this.makeRequest("/api/auth/verify", verifyRequest);
      let accessToken;
      let refreshToken;
      let user;
      if (response.data.tokens) {
        accessToken = response.data.tokens.accessToken;
        refreshToken = response.data.tokens.refreshToken;
        user = response.data.user;
      } else {
        accessToken = response.data.accessToken;
        refreshToken = response.data.refreshToken;
        user = response.data.user;
      }
      if (!accessToken) {
        throw new Error("No access token received from server");
      }
      const tokens = {
        accessToken,
        refreshToken,
        walletAddress,
        walletType: detectedType,
        expiresAt: Date.now() + 24 * 60 * 60 * 1e3,
        // 24 hours
        user
      };
      this.saveAuthTokens(tokens);
      if (this.config.verbose) {
        console.log("\u{1F389} Authentication successful!");
        console.log(`\u{1F464} User: ${user?.walletAddress} (Role: ${user?.role})`);
      }
      return tokens;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      console.error("\u274C Authentication failed:", message);
      throw new Error(`Authentication failed: ${message}`);
    }
  }
  /**
   * Refresh authentication tokens
   */
  async refreshTokens() {
    try {
      const stored = this.loadAuthTokens();
      if (!stored) {
        if (this.config.verbose) {
          console.log("\u274C No stored tokens to refresh");
        }
        return null;
      }
      if (this.config.verbose) {
        console.log("\u{1F504} Refreshing tokens...");
      }
      const refreshRequest = {
        refreshToken: stored.refreshToken
      };
      const response = await this.makeRequest("/api/auth/refresh", refreshRequest);
      let accessToken;
      let refreshToken;
      if (response.data.tokens) {
        accessToken = response.data.tokens.accessToken;
        refreshToken = response.data.tokens.refreshToken;
      } else {
        accessToken = response.data.accessToken;
        refreshToken = response.data.refreshToken;
      }
      if (!accessToken) {
        if (this.config.verbose) {
          console.log("\u274C No access token in refresh response");
        }
        return null;
      }
      const tokens = {
        ...stored,
        accessToken,
        refreshToken: refreshToken || stored.refreshToken,
        // Keep old refresh token if not provided
        expiresAt: Date.now() + 24 * 60 * 60 * 1e3
      };
      this.saveAuthTokens(tokens);
      if (this.config.verbose) {
        console.log("\u2705 Tokens refreshed successfully");
      }
      return tokens;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      if (this.config.verbose) {
        console.log("\u274C Token refresh failed:", message);
      }
      return null;
    }
  }
  /**
   * Validate current authentication token
   */
  async validateToken() {
    try {
      const stored = this.loadAuthTokens();
      if (!stored) {
        if (this.config.verbose) {
          console.log("\u274C No stored tokens found");
        }
        return false;
      }
      if (this.config.verbose) {
        console.log("\u{1F50D} Validating token...");
      }
      const response = await this.makeRequest("/api/auth/validate", void 0, stored.accessToken);
      if (this.config.verbose) {
        console.log("\u2705 Token is valid");
        console.log(`\u{1F464} Authenticated as: ${response.data.walletAddress}`);
        console.log(`\u{1F3AD} Role: ${response.data.role}`);
      }
      return true;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      if (this.config.verbose) {
        console.error("\u274C Token validation failed:", message);
      }
      return false;
    }
  }
  /**
   * Get authentication status and user info
   */
  async getAuthStatus() {
    const tokens = this.loadAuthTokens();
    if (!tokens) {
      return { authenticated: false };
    }
    const isValid = await this.validateToken();
    return {
      authenticated: isValid,
      user: tokens.user,
      tokens: isValid ? tokens : void 0
    };
  }
  /**
   * Ensure valid authentication (refresh if needed)
   */
  async ensureValidAuth() {
    let tokens = this.loadAuthTokens();
    if (!tokens) {
      return null;
    }
    if (this.shouldRefreshToken(tokens)) {
      const refreshedTokens = await this.refreshTokens();
      if (refreshedTokens) {
        tokens = refreshedTokens;
      }
    }
    return tokens;
  }
  /**
   * Export tokens for external use (curl, etc.)
   */
  exportForCurl() {
    const tokens = this.loadAuthTokens();
    if (!tokens) {
      console.log("\u274C No authentication tokens found");
      return;
    }
    console.log("\n\u{1F4CB} cURL Export:");
    console.log("\u2550".repeat(50));
    console.log(`export AUTH_TOKEN="${tokens.accessToken}"`);
    console.log(`export API_BASE_URL="${this.config.apiBaseUrl}"`);
    console.log("");
    console.log("# Example usage:");
    console.log('curl -H "Authorization: Bearer $AUTH_TOKEN" "$API_BASE_URL/api/users/me"');
    console.log('curl -H "Authorization: Bearer $AUTH_TOKEN" "$API_BASE_URL/api/projects"');
    console.log("\u2550".repeat(50));
  }
};

// src/services/api-client.ts
import axios2 from "axios";
var ApiClient = class {
  constructor(config) {
    this.config = {
      timeout: 1e4,
      retries: 3,
      verbose: false,
      ...config
    };
    this.authManager = config.authManager;
  }
  // ===== QUERY BUILDING =====
  /**
   * Build query string from parameters
   */
  buildQueryString(params) {
    const sanitized = sanitizeQueryParams(params);
    const entries = Object.entries(sanitized);
    if (entries.length === 0) {
      return "";
    }
    const queryParts = entries.map(([key, value]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    });
    return `?${queryParts.join("&")}`;
  }
  /**
   * Normalize endpoint path
   */
  normalizeEndpoint(endpoint) {
    let normalized = endpoint.trim();
    if (!normalized.startsWith("/")) {
      normalized = `/${normalized}`;
    }
    return normalized;
  }
  // ===== REQUEST EXECUTION =====
  /**
   * Execute HTTP request with retry logic
   */
  async executeRequest(config, options = {}) {
    const maxRetries = options.retries || this.config.retries || 3;
    let lastError;
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        if (options.verbose && !options.silent) {
          console.log(`\u{1F504} Attempt ${attempt + 1}/${maxRetries + 1}: ${config.method?.toUpperCase()} ${config.url}`);
        }
        const response = await axios2(config);
        if (options.verbose && !options.silent) {
          console.log(`\u2705 Request successful: ${response.status} ${response.statusText}`);
        }
        return response;
      } catch (error) {
        lastError = error;
        if (error.response?.status >= 400 && error.response?.status < 500) {
          break;
        }
        if (attempt === maxRetries) {
          break;
        }
        if (options.verbose && !options.silent) {
          console.log(`\u26A0\uFE0F  Attempt ${attempt + 1} failed, retrying...`);
        }
        const delay = Math.min(1e3 * Math.pow(2, attempt), 5e3);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
    throw lastError;
  }
  // ===== AUTHENTICATED REQUESTS =====
  /**
   * Make authenticated request with automatic token refresh
   */
  async makeAuthenticatedRequest(method, endpoint, data, params, options = {}) {
    if (!this.authManager) {
      throw new Error("AuthManager not configured for authenticated requests");
    }
    const tokens = await this.authManager.ensureValidAuth();
    if (!tokens) {
      throw new Error("No valid authentication tokens available");
    }
    const normalizedEndpoint = this.normalizeEndpoint(endpoint);
    const queryString = params ? this.buildQueryString(params) : "";
    const url = `${this.config.baseUrl}${normalizedEndpoint}${queryString}`;
    const requestConfig = {
      method,
      url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokens.accessToken}`,
        ...options.headers
      },
      data,
      timeout: options.timeout || this.config.timeout
    };
    if (options.verbose && !options.silent) {
      console.log("\u{1F50D} Request config:", {
        method: requestConfig.method,
        url: requestConfig.url,
        headers: requestConfig.headers,
        data: requestConfig.data
      });
    }
    try {
      const response = await this.executeRequest(requestConfig, options);
      if (options.includeHeaders) {
        return {
          data: response.data,
          status: response.status,
          statusText: response.statusText,
          headers: response.headers
        };
      }
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
        headers: {}
      };
    } catch (error) {
      if (error.response?.status === 401) {
        if (options.verbose && !options.silent) {
          console.log("\u{1F504} 401 error, attempting token refresh...");
        }
        const refreshedTokens = await this.authManager.refreshTokens();
        if (refreshedTokens) {
          requestConfig.headers.Authorization = `Bearer ${refreshedTokens.accessToken}`;
          try {
            const retryResponse = await this.executeRequest(requestConfig, options);
            if (options.includeHeaders) {
              return {
                data: retryResponse.data,
                status: retryResponse.status,
                statusText: retryResponse.statusText,
                headers: retryResponse.headers
              };
            }
            return {
              data: retryResponse.data,
              status: retryResponse.status,
              statusText: retryResponse.statusText,
              headers: {}
            };
          } catch (retryError) {
            if (!options.silent) {
              console.error(`\u274C Request failed after token refresh: ${formatError(retryError)}`);
            }
            throw retryError;
          }
        } else {
          if (!options.silent) {
            console.error("\u274C Token refresh failed. Please re-authenticate.");
          }
          throw new Error("Authentication failed");
        }
      }
      if (!options.silent) {
        console.error(`\u274C Request failed: ${formatError(error)}`);
      }
      throw error;
    }
  }
  // ===== PUBLIC REQUESTS =====
  /**
   * Make public (non-authenticated) request
   */
  async makePublicRequest(method, endpoint, data, params, options = {}) {
    const normalizedEndpoint = this.normalizeEndpoint(endpoint);
    const queryString = params ? this.buildQueryString(params) : "";
    const url = `${this.config.baseUrl}${normalizedEndpoint}${queryString}`;
    const requestConfig = {
      method,
      url,
      headers: {
        "Content-Type": "application/json",
        ...options.headers
      },
      data,
      timeout: options.timeout || this.config.timeout
    };
    if (options.verbose && !options.silent) {
      console.log("\u{1F50D} Public request config:", {
        method: requestConfig.method,
        url: requestConfig.url,
        headers: requestConfig.headers,
        data: requestConfig.data
      });
    }
    try {
      const response = await this.executeRequest(requestConfig, options);
      if (options.includeHeaders) {
        return {
          data: response.data,
          status: response.status,
          statusText: response.statusText,
          headers: response.headers
        };
      }
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
        headers: {}
      };
    } catch (error) {
      if (!options.silent) {
        console.error(`\u274C Public request failed: ${formatError(error)}`);
      }
      throw error;
    }
  }
  // ===== CONVENIENCE METHODS =====
  /**
   * GET request
   */
  async get(endpoint, params, options = {}) {
    if (this.authManager) {
      return this.makeAuthenticatedRequest("GET", endpoint, void 0, params, options);
    } else {
      return this.makePublicRequest("GET", endpoint, void 0, params, options);
    }
  }
  /**
   * POST request
   */
  async post(endpoint, data, options = {}) {
    if (this.authManager) {
      return this.makeAuthenticatedRequest("POST", endpoint, data, void 0, options);
    } else {
      return this.makePublicRequest("POST", endpoint, data, void 0, options);
    }
  }
  /**
   * PUT request
   */
  async put(endpoint, data, options = {}) {
    if (this.authManager) {
      return this.makeAuthenticatedRequest("PUT", endpoint, data, void 0, options);
    } else {
      return this.makePublicRequest("PUT", endpoint, data, void 0, options);
    }
  }
  /**
   * DELETE request
   */
  async delete(endpoint, options = {}) {
    if (this.authManager) {
      return this.makeAuthenticatedRequest("DELETE", endpoint, void 0, void 0, options);
    } else {
      return this.makePublicRequest("DELETE", endpoint, void 0, void 0, options);
    }
  }
  /**
   * PATCH request
   */
  async patch(endpoint, data, options = {}) {
    if (this.authManager) {
      return this.makeAuthenticatedRequest("PATCH", endpoint, data, void 0, options);
    } else {
      return this.makePublicRequest("PATCH", endpoint, data, void 0, options);
    }
  }
  // ===== UTILITY METHODS =====
  /**
   * Test API connectivity
   */
  async testConnection() {
    try {
      const response = await this.makePublicRequest("GET", "/health", void 0, void 0, { silent: true });
      return response.status >= 200 && response.status < 300;
    } catch {
      return false;
    }
  }
  /**
   * Update base URL
   */
  updateBaseUrl(baseUrl) {
    this.config.baseUrl = baseUrl;
  }
  /**
   * Set auth manager
   */
  setAuthManager(authManager) {
    this.authManager = authManager;
  }
  /**
   * Get current configuration
   */
  getConfig() {
    return { ...this.config };
  }
};

// src/services/config-manager.ts
import fs2 from "fs";
import path2 from "path";
import os2 from "os";
var ConfigManager = class {
  constructor(options = {}) {
    this.cache = null;
    this.options = {
      configDir: path2.join(os2.homedir(), ".wearesage"),
      configFileName: "config.json",
      createIfMissing: true,
      verbose: false,
      ...options
    };
    this.configPath = path2.join(this.options.configDir, this.options.configFileName);
  }
  // ===== FILE OPERATIONS =====
  /**
   * Ensure config directory exists
   */
  ensureConfigDir() {
    if (!fs2.existsSync(this.options.configDir)) {
      fs2.mkdirSync(this.options.configDir, { recursive: true });
      if (this.options.verbose) {
        console.log(`\u2705 Created config directory: ${this.options.configDir}`);
      }
    }
  }
  /**
   * Load configuration from file
   */
  load() {
    try {
      if (!fs2.existsSync(this.configPath)) {
        if (this.options.createIfMissing) {
          return this.createDefault();
        } else {
          throw new Error(`Config file not found: ${this.configPath}`);
        }
      }
      const data = fs2.readFileSync(this.configPath, "utf8");
      const config = JSON.parse(data);
      this.cache = config;
      if (this.options.verbose) {
        console.log(`\u2705 Config loaded from: ${this.configPath}`);
      }
      return config;
    } catch (error) {
      if (this.options.verbose) {
        console.error("\u274C Failed to load config:", error.message);
      }
      if (this.options.createIfMissing && error.code === "ENOENT") {
        return this.createDefault();
      }
      throw new Error(`Failed to load config: ${error.message}`);
    }
  }
  /**
   * Save configuration to file
   */
  save(config) {
    try {
      this.ensureConfigDir();
      const configJson = JSON.stringify(config, null, 2);
      fs2.writeFileSync(this.configPath, configJson, "utf8");
      this.cache = config;
      if (this.options.verbose) {
        console.log(`\u2705 Config saved to: ${this.configPath}`);
      }
    } catch (error) {
      console.error("\u274C Failed to save config:", error.message);
      throw new Error(`Failed to save config: ${error.message}`);
    }
  }
  /**
   * Create default configuration
   */
  createDefault() {
    const defaultConfig = {};
    this.save(defaultConfig);
    return defaultConfig;
  }
  // ===== CONFIGURATION ACCESS =====
  /**
   * Get configuration value
   */
  get(key) {
    const config = this.cache || this.load();
    return config[key];
  }
  /**
   * Set configuration value
   */
  set(key, value) {
    const config = this.cache || this.load();
    config[key] = value;
    this.save(config);
  }
  /**
   * Get multiple configuration values
   */
  getMultiple(keys) {
    const config = this.cache || this.load();
    const result = {};
    for (const key of keys) {
      if (key in config) {
        result[key] = config[key];
      }
    }
    return result;
  }
  /**
   * Set multiple configuration values
   */
  setMultiple(values) {
    const config = this.cache || this.load();
    Object.assign(config, values);
    this.save(config);
  }
  /**
   * Get entire configuration
   */
  getAll() {
    return this.cache || this.load();
  }
  /**
   * Update configuration with merge
   */
  update(updates) {
    const config = this.cache || this.load();
    const updated = { ...config, ...updates };
    this.save(updated);
  }
  /**
   * Reset configuration to defaults
   */
  reset() {
    this.cache = null;
    if (fs2.existsSync(this.configPath)) {
      fs2.unlinkSync(this.configPath);
    }
    return this.createDefault();
  }
  // ===== UTILITY METHODS =====
  /**
   * Check if configuration exists
   */
  exists() {
    return fs2.existsSync(this.configPath);
  }
  /**
   * Get configuration file path
   */
  getConfigPath() {
    return this.configPath;
  }
  /**
   * Validate configuration
   */
  validate(config) {
    return { valid: true, errors: [] };
  }
};
var CliConfigManager = class extends ConfigManager {
  createDefault() {
    const defaultConfig = {
      apiUrl: "http://localhost:2223",
      outputFormat: "pretty",
      autoCorrect: true,
      verbose: false,
      auth: {},
      ai: {
        ollamaModel: "gemma3:12b-it-qat",
        maxTokens: 4e3,
        temperature: 0.7
      }
    };
    this.save(defaultConfig);
    return defaultConfig;
  }
  validate(config) {
    const errors = [];
    if (config.apiUrl && !isValidUrl(config.apiUrl)) {
      errors.push("Invalid API URL format");
    }
    if (config.outputFormat && !isValidOutputFormat(config.outputFormat)) {
      errors.push("Invalid output format. Must be: pretty, json, yaml, table, or csv");
    }
    if (config.ai?.maxTokens && (config.ai.maxTokens < 100 || config.ai.maxTokens > 1e4)) {
      errors.push("AI maxTokens must be between 100 and 10000");
    }
    if (config.ai?.temperature && (config.ai.temperature < 0 || config.ai.temperature > 2)) {
      errors.push("AI temperature must be between 0 and 2");
    }
    return {
      valid: errors.length === 0,
      errors
    };
  }
  // CLI-specific helper methods
  getApiUrl() {
    return this.get("apiUrl") || "http://localhost:2223";
  }
  setApiUrl(url) {
    const validation = this.validate({ apiUrl: url });
    if (!validation.valid) {
      throw new Error(`Invalid API URL: ${validation.errors.join(", ")}`);
    }
    this.set("apiUrl", url);
  }
  getOutputFormat() {
    return this.get("outputFormat") || "pretty";
  }
  setOutputFormat(format) {
    const validation = this.validate({ outputFormat: format });
    if (!validation.valid) {
      throw new Error(`Invalid output format: ${validation.errors.join(", ")}`);
    }
    this.set("outputFormat", format);
  }
  isVerbose() {
    return this.get("verbose") || false;
  }
  setVerbose(verbose) {
    this.set("verbose", verbose);
  }
  getOllamaModel() {
    return this.get("ai")?.ollamaModel || "gemma3:12b-it-qat";
  }
  setOllamaModel(model) {
    const ai = this.get("ai") || { ollamaModel: "", maxTokens: 4e3, temperature: 0.7 };
    ai.ollamaModel = model;
    this.set("ai", ai);
  }
};
var ApiConfigManager = class extends ConfigManager {
  createDefault() {
    const defaultConfig = {
      port: 2223,
      host: "0.0.0.0",
      cors: {
        origin: ["http://localhost:2223", "http://localhost:5173"],
        credentials: true
      },
      rateLimit: {
        windowMs: 15 * 60 * 1e3,
        // 15 minutes
        max: 1e3
        // requests per window
      },
      auth: {
        jwtSecret: process.env.JWT_SECRET || "dev-secret-change-in-production",
        tokenExpiry: "24h",
        refreshTokenExpiry: "7d"
      },
      database: {
        url: process.env.DATABASE_URL || "postgresql://localhost/wearesage_dev",
        maxConnections: 20
      },
      redis: {
        url: process.env.REDIS_URL || "redis://localhost:6379",
        keyPrefix: "ws:"
      }
    };
    this.save(defaultConfig);
    return defaultConfig;
  }
  validate(config) {
    const errors = [];
    if (config.port && (config.port < 1 || config.port > 65535)) {
      errors.push("Port must be between 1 and 65535");
    }
    if (config.database?.url && !config.database.url.includes("://")) {
      errors.push("Database URL must include protocol (postgresql://, mysql://, etc.)");
    }
    if (config.redis?.url && !config.redis.url.includes("://")) {
      errors.push("Redis URL must include protocol (redis://, rediss://)");
    }
    if (config.rateLimit?.max && config.rateLimit.max < 1) {
      errors.push("Rate limit max must be greater than 0");
    }
    return {
      valid: errors.length === 0,
      errors
    };
  }
};
var EnvironmentManager = class {
  /**
   * Get environment variables with defaults
   */
  static getEnvironment() {
    return {
      NODE_ENV: process.env.NODE_ENV || "development",
      API_URL: process.env.API_URL,
      DATABASE_URL: process.env.DATABASE_URL,
      REDIS_URL: process.env.REDIS_URL,
      JWT_SECRET: process.env.JWT_SECRET,
      SAGE_API_URL: process.env.SAGE_API_URL,
      SAGE_WALLET_ADDRESS: process.env.SAGE_WALLET_ADDRESS,
      SAGE_PRIVATE_KEY: process.env.SAGE_PRIVATE_KEY,
      SAGE_AUTH_TOKEN: process.env.SAGE_AUTH_TOKEN,
      SAGE_OUTPUT_FORMAT: process.env.SAGE_OUTPUT_FORMAT
    };
  }
  /**
   * Check if running in production
   */
  static isProduction() {
    return process.env.NODE_ENV === "production";
  }
  /**
   * Check if running in development
   */
  static isDevelopment() {
    return process.env.NODE_ENV === "development" || !process.env.NODE_ENV;
  }
  /**
   * Check if running in test
   */
  static isTest() {
    return process.env.NODE_ENV === "test";
  }
  /**
   * Get required environment variable
   */
  static getRequired(key) {
    const value = process.env[key];
    if (!value) {
      throw new Error(`Required environment variable ${key} is not set`);
    }
    return value;
  }
  /**
   * Get environment variable with default
   */
  static get(key, defaultValue) {
    return process.env[key] || defaultValue;
  }
};

// src/services/query-builder.ts
var QueryBuilder = class {
  constructor(options = {}) {
    this.resolver = getSmartEnumResolver();
    this.options = {
      autoResolveEnums: true,
      allowUnresolved: true,
      verbose: false,
      ...options
    };
  }
  // ===== SYNTAX PARSING =====
  /**
   * Parse function-style parameters: users(usa,spotify,mobile)
   */
  parseFunctionStyle(input) {
    const match = input.match(/\(([^)]+)\)/);
    if (!match) {
      return [];
    }
    const content = match[1];
    const terms = [];
    const parts = this.splitWithQuotes(content, ",");
    for (const part of parts) {
      const trimmed = part.trim();
      if (!trimmed) continue;
      if (trimmed.includes("=")) {
        const [key, ...valueParts] = trimmed.split("=");
        const value = valueParts.join("=").trim();
        const cleanValue = this.removeQuotes(value);
        terms.push({
          raw: `${key.trim()}=${cleanValue}`,
          type: "literal"
        });
      } else {
        const cleanTerm = this.removeQuotes(trimmed);
        terms.push({
          raw: cleanTerm,
          type: "enum"
        });
      }
    }
    return terms;
  }
  /**
   * Parse query string style: ?country=USA&source=SPOTIFY
   */
  parseQueryString(input) {
    if (!input.includes("?")) {
      return [];
    }
    const queryPart = input.split("?")[1];
    const terms = [];
    const params = new URLSearchParams(queryPart);
    for (const [key, value] of params.entries()) {
      terms.push({
        raw: `${key}=${value}`,
        type: "literal"
      });
    }
    return terms;
  }
  /**
   * Parse JSON object style: {"country":"USA","source":"SPOTIFY"}
   */
  parseJsonStyle(input) {
    const parseResult = safeJSONParse(input);
    if (!parseResult.success) {
      return [];
    }
    const terms = [];
    const obj = parseResult.data;
    if (typeof obj === "object" && obj !== null) {
      for (const [key, value] of Object.entries(obj)) {
        terms.push({
          raw: `${key}=${String(value)}`,
          type: "literal"
        });
      }
    }
    return terms;
  }
  // ===== UTILITY METHODS =====
  /**
   * Split string by delimiter while respecting quoted strings
   */
  splitWithQuotes(input, delimiter) {
    const parts = [];
    let current = "";
    let inQuotes = false;
    let quoteChar = "";
    for (let i = 0; i < input.length; i++) {
      const char = input[i];
      if ((char === '"' || char === "'") && !inQuotes) {
        inQuotes = true;
        quoteChar = char;
        current += char;
      } else if (char === quoteChar && inQuotes) {
        inQuotes = false;
        quoteChar = "";
        current += char;
      } else if (char === delimiter && !inQuotes) {
        parts.push(current);
        current = "";
      } else {
        current += char;
      }
    }
    if (current) {
      parts.push(current);
    }
    return parts;
  }
  /**
   * Remove surrounding quotes from string
   */
  removeQuotes(input) {
    const trimmed = input.trim();
    if (trimmed.startsWith('"') && trimmed.endsWith('"') || trimmed.startsWith("'") && trimmed.endsWith("'")) {
      return trimmed.slice(1, -1);
    }
    return trimmed;
  }
  // ===== ENUM RESOLUTION =====
  /**
   * Resolve terms using smart enum mapping
   */
  resolveTerms(terms) {
    if (!this.options.autoResolveEnums) {
      return terms;
    }
    return terms.map((term) => {
      if (term.type === "enum") {
        const resolved = this.resolver.resolve(term.raw);
        if (resolved !== null) {
          return {
            ...term,
            resolved
          };
        }
      }
      return term;
    });
  }
  // ===== QUERY BUILDING =====
  /**
   * Convert resolved terms to query parameters
   */
  buildQueryParams(terms) {
    const params = {};
    for (const term of terms) {
      if (term.type === "literal" && term.raw.includes("=")) {
        const [key, ...valueParts] = term.raw.split("=");
        const value = valueParts.join("=");
        params[key.trim()] = value;
      } else if (term.type === "enum" && term.resolved !== void 0) {
        const paramName = this.inferParameterName(term.resolved);
        if (paramName) {
          params[paramName] = String(term.resolved);
        }
      }
    }
    return sanitizeQueryParams(params);
  }
  /**
   * Infer parameter name from enum value
   * This maps enum ranges back to their likely parameter names
   */
  inferParameterName(enumValue) {
    if (enumValue >= 0 && enumValue <= 3) return "role";
    if (enumValue >= 1 && enumValue <= 7) return "audioSource";
    if (enumValue >= 0 && enumValue <= 6) return "deviceType";
    if (enumValue >= 13 && enumValue <= 23) return "os";
    if (enumValue >= 24 && enumValue <= 70) return "country";
    if (enumValue >= 71 && enumValue <= 75) return "shaderType";
    if (enumValue >= 76 && enumValue <= 100) return "tag";
    if (enumValue >= 101 && enumValue <= 107) return "performance";
    if (enumValue >= 108 && enumValue <= 115) return "quality";
    if (enumValue >= 116 && enumValue <= 130) return "framework";
    if (enumValue >= 131 && enumValue <= 141) return "timePeriod";
    if (enumValue >= 142 && enumValue <= 157) return "sortBy";
    if (enumValue >= 158 && enumValue <= 161) return "sortOrder";
    if (enumValue >= 162 && enumValue <= 169) return "role";
    return null;
  }
  // ===== PUBLIC API =====
  /**
   * Parse query from various input formats
   */
  parseQuery(input) {
    const suggestions = [];
    const errors = [];
    let terms = [];
    if (this.options.verbose) {
      console.log(`\u{1F50D} Parsing query: "${input}"`);
    }
    if (input.includes("(") && input.includes(")")) {
      terms = this.parseFunctionStyle(input);
      if (this.options.verbose) {
        console.log("\u{1F4DD} Detected function-style syntax");
      }
    } else if (input.includes("?")) {
      terms = this.parseQueryString(input);
      if (this.options.verbose) {
        console.log("\u{1F4DD} Detected query-string syntax");
      }
    } else if (input.trim().startsWith("{")) {
      terms = this.parseJsonStyle(input);
      if (this.options.verbose) {
        console.log("\u{1F4DD} Detected JSON syntax");
      }
    } else {
      terms = [{ raw: input.trim(), type: "enum" }];
      if (this.options.verbose) {
        console.log("\u{1F4DD} Treating as single term");
      }
    }
    const resolvedTerms = this.resolveTerms(terms);
    for (const term of resolvedTerms) {
      if (term.type === "enum" && term.resolved === void 0) {
        if (!this.options.allowUnresolved) {
          errors.push(`Unresolved term: "${term.raw}"`);
        }
        const termSuggestions = this.resolver.getSuggestions(term.raw, 3);
        suggestions.push(...termSuggestions);
      }
    }
    const params = this.buildQueryParams(resolvedTerms);
    if (this.options.verbose) {
      console.log("\u2705 Parse result:", {
        terms: resolvedTerms.length,
        params: Object.keys(params).length,
        suggestions: suggestions.length,
        errors: errors.length
      });
    }
    return {
      terms: resolvedTerms,
      params,
      suggestions: [...new Set(suggestions)],
      // Remove duplicates
      errors
    };
  }
  /**
   * Build query string from smart terms
   */
  buildQueryString(input) {
    const parsed = this.parseQuery(input);
    if (parsed.errors.length > 0 && !this.options.allowUnresolved) {
      throw new Error(`Query parsing failed: ${parsed.errors.join(", ")}`);
    }
    const paramEntries = Object.entries(parsed.params);
    if (paramEntries.length === 0) {
      return "";
    }
    const queryParts = paramEntries.map(([key, value]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
    });
    return `?${queryParts.join("&")}`;
  }
  /**
   * Get suggestions for a partial query
   */
  getSuggestions(input, limit = 5) {
    let lastTerm = input;
    if (input.includes("(")) {
      const parts = input.split(/[(),]/);
      lastTerm = parts[parts.length - 1]?.trim() || "";
    } else if (input.includes("&")) {
      const parts = input.split("&");
      lastTerm = parts[parts.length - 1]?.trim() || "";
    }
    return this.resolver.getSuggestions(lastTerm, limit);
  }
  /**
   * Check if a query is valid
   */
  isValidQuery(input) {
    try {
      const parsed = this.parseQuery(input);
      return parsed.errors.length === 0;
    } catch {
      return false;
    }
  }
  /**
   * Get available enum terms for autocomplete
   */
  getAvailableTerms() {
    return [
      "usa",
      "uk",
      "canada",
      "australia",
      "spotify",
      "audius",
      "kexp",
      "mobile",
      "desktop",
      "tablet",
      "audio",
      "generative",
      "cyberpunk",
      "today",
      "week",
      "month",
      "year",
      "popular",
      "trending",
      "featured",
      "public",
      "private",
      "unlisted"
    ];
  }
};
export {
  ADMIN_WALLET,
  ActivityType,
  Adapter,
  AnalyticsMetric,
  ApiClient,
  ApiConfigManager,
  AppTarget,
  AudioSource,
  AuthManager,
  CORE_TEST_USERS,
  CliConfigManager,
  ClientPlatform,
  CollaborationRole,
  Component,
  ConfigManager,
  ConsciousnessMessageType,
  ContentVisibility,
  Controller,
  Country,
  CurrentPage,
  DEFAULT_USER_PREFERENCES,
  Delete,
  Description,
  DeviceType,
  EXTENDED_TEST_USERS,
  EmotionalTone,
  EnvironmentManager,
  Framework,
  GeoRegion,
  Get,
  Middleware,
  Model,
  NoOp,
  OperatingSystem,
  Patch,
  PerformanceLevel,
  PlaybackState,
  Post,
  ProjectContext,
  ProjectStatus,
  Put,
  Quality,
  QueryBuilder,
  RadioParadiseStation,
  RadioSource,
  RadioStreamUrls,
  RedisKeys,
  Repository,
  Route,
  RouterModeMap,
  SMART_ENUM_MAP,
  Service,
  ShaderCategory,
  ShaderType,
  SmartEnumResolver,
  SocketActivity,
  SocketCore,
  SocketCrud,
  SocketEntity,
  SocketEventCategories,
  SocketEvents,
  SocketRoom,
  SocketSocial,
  SortBy,
  SortOrder,
  SpaceType,
  SpaceVisibility,
  SpecialWallets,
  TEST_USER_COLORS,
  TEST_USER_DISPLAY_NAMES,
  TEST_USER_SHORT_NAMES,
  TaskPriority,
  TaskStatus,
  Team,
  TechnicalContext,
  TimePeriod,
  UserRole,
  UserStateField,
  UserStatus,
  Utility,
  View,
  VisualTag,
  createProjectEvent,
  createSocketEvent,
  createTaskEvent,
  detectWalletType,
  enumKeyToLabel,
  enumToString,
  formatBytes,
  formatDuration,
  formatError,
  formatJSON,
  formatKey,
  formatPercentage,
  formatStatus,
  formatTimestamp,
  generateSocketEvent,
  getEnumValues,
  getMetadata,
  getRoutes,
  getSmartEnumResolver,
  getTestUserByWallet,
  getTestUserStats,
  getTestUsersByRole,
  getTestUsersForEnvironment,
  hasDecorator,
  isValidEndpoint,
  isValidEnumValue,
  isValidEthereumAddress,
  isValidEthereumPrivateKey,
  isValidHttpMethod,
  isValidJSON,
  isValidOutputFormat,
  isValidSolanaAddress,
  isValidSolanaPrivateKey,
  isValidUrl,
  isValidWalletAddress,
  normalizePrivateKey,
  resolveSmartEnum,
  safeJSONParse,
  sanitizeEndpoint,
  sanitizeQueryParams,
  sanitizeString,
  sanitizeWalletAddress,
  truncateAddress,
  validatePagination
};
